import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, HostListener, QueryList, ViewChildren} from '@angular/core';
import {BehaviorSubject, Subject, Subscription, combineLatest, interval, of, forkJoin} from 'rxjs';
import { InstallationService } from '../../../../core/installation/services/installation.service';
import { LocationTypeLabels } from '../../../../core/installation/location-type-labels';
import * as _ from 'lodash';
import {catchError, debounceTime, filter, map, startWith, switchMap, take, tap} from 'rxjs/operators';
import { AlarmService } from '../../../../core/alarm/services/alarm.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
/*import { QueryParamsModel } from '../../../../core/_base/crud';
import Swal from 'sweetalert2';
import { AlarmActionService } from '../../../../core/alarm/services/alarm-action.service';
import { CommentTypeService } from '../../../../core/alarm/services/comment-type.service';*/
import { mapOptions } from '../../../../core/config/map.config';
import {GoogleMap, MapInfoWindow, MapMarker} from '@angular/google-maps';
import {timestamp} from "../../../../core/_base/util/date.util";
import {GLOBAL_AUTH_SERVER_ADDRESS_SSL} from "../../../../core/core.global";
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import {response} from './sensor_data'

@Component({
  selector: 'app-installation-map',
  templateUrl: './installation-map.component.html',
  styleUrls: ['./installation-map.component.scss']
})
export class InstallationMapComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @ViewChild('modalTemplate', { read: TemplateRef }) modalTemplate:TemplateRef<any>;
  @Input() installationList: any[] = null;
  @Input() alarmList: any[] = null;
  @Input() zoneColorByLatestStatus: boolean = true;
  @Input() showLegend: boolean = false;
  @Input() locationId: number|null = null;
  @Input() installationId: number | null = null;
  @Input() alarm: any = null;
  @Input() mapHeight = '400px';
  @Input() showFullscreenButton = true;
  @Input() selectionMode = false;
  @Input() showMapMarkers = true;
  @Input() showMapLines = true;
  @Input() hideGoogleMapControls = false;
  @Output() locationSelected = new EventEmitter<any>();
  @BlockUI('section-block') blockUI: NgBlockUI;
  mapLegendLoaded: boolean = false;
  mapOptions = mapOptions;
  isFullscreen = false;
  copyDiv: any;
  expandBox = true;
  /*Bloqueado →azul (siac_status_id = 5)
  Armado → verde (siac_status_id = 2)
  Des-armado → amarillo(siac_status_id = 3)
  Alarmado → rojo (siac_status_id = 4)
  Apagado → gris (siac_status_id = 1)*/
  public colors = [
    { name: 'Bloqueado', hex: '#140bbf' },
    { name: 'Armado', hex: '#0B986A' },
    { name: 'Des-armado', hex: '#FAD92A' },
    { name: 'Alarmado', hex: '#F51E1E' },
    { name: 'Apagado', hex: '#4A4949' }
  ]
  public iconMarkers = [
    /*{
      position: { lat: -33.1187686, lng: -70.8258803 },
      icon: {
        url: 'assets/icons/dash/Vector26.svg',
        scaledSize: { width: 40, height: 40 }
      }
    },
    {
      position: { lat: -33.118764, lng: -70.825100 },
      icon: {
        url: 'assets/icons/dash/Vector27.svg',
        scaledSize: { width: 40, height: 40 }
      }
    },
    {
      position: { lat: -33.118760, lng: -70.825300 },
      icon: {
        url: 'assets/icons/dash/Vector28.svg',
        scaledSize: { width: 40, height: 40 }
      }
    },
    {
      position: { lat: -33.1187441, lng: -70.8247883 },
      icon: {
        url: 'assets/icons/dash/Vector29.svg',
        scaledSize: { width: 40, height: 40 }
      }
    },
    {
      position: { lat: -33.118750, lng: -70.825400 },
      icon: {
        url: 'assets/icons/dash/Vector30.svg',
        scaledSize: { width: 40, height: 40 }
      }
    }*/
  ];
  /**
   * Marker Circle Polygon Component
   */
  public markerCirclePolygonCenter = { lat: 37.421995, lng: -122.084092 };
  public markerCirclePolygonZoom = 15;
  public mapCircleCenter: google.maps.LatLngLiteral = { lat: 37.421995, lng: -122.084092 };

  public mapCircleOptions = {
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    radius: 200,
    fillColor: '#FF0000',
    fillOpacity: 0.35,
    draggable: false,
    center: { lat: 37.421995, lng: -122.084092 },
  };

  // Define the LatLng coordinates for the polygon's  outer path.
  private polygonCoords = [
    { lat: 37.421834, lng: -122.079971 },
    { lat: 37.421672, lng: -122.07273 },
    { lat: 37.419884, lng: -122.079213 }
  ];

  public mapPolygonPaths = [this.polygonCoords];

  public mapPolygonOptions = {
    strokeColor: '#3164bf',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    radius: 200,
    fillColor: '#3164bf',
    fillOpacity: 0.35,
    draggable: false,
    center: { lat: 37.421995, lng: -122.084092 }
  };

  installationList_: any[] = [];
  installations$ = new BehaviorSubject<any []>(null);
  mapMode = 'satellite' // normal | satellite

  private subscriptions: Subscription[] = [];
  /** Evita que callbacks de Google Maps o de peticiones pendientes actualicen
   *  una instancia cuyo mapa ya fue retirado al cambiar de ruta. */
  private destroyed = false;
  private pendingTimeouts = new Set<ReturnType<typeof setTimeout>>();
  markersLoaded: boolean = false;
  // deviceList: any[];
  markers: any[] = [];
  /**
   * Zoom desde el que los pines con la misma coordenada se separan en círculo;
   * con un zoom menor se muestran agrupados en un único pin.
   */
  readonly OVERLAP_SEPARATE_ZOOM = 19;
  /**
   * Tarjetas de alarma ancladas al pin con el pico nativo de Google Maps (como satif_apk).
   * En false se vuelve a la distribución en abanico con triángulos propios.
   */
  readonly ANCHORED_TOOLTIPS = true;
  polyLines: any[] = [];
  tooltipConnectors: any[] = [];
  // infoWindows: any[] = [];
  slideOpts = {
    initialSlide: 0,
    speed: 400
  };
  // slides: any = [
  //   /*{img: 'https://img.freepik.com/free-photo/painting-mountain-lake-with-mountain-background_188544-9126.jpg'},
  //   {img: 'https://img.freepik.com/free-photo/painting-mountain-lake-with-mountain-background_188544-9126.jpg'},
  //   {img: 'https://img.freepik.com/free-photo/painting-mountain-lake-with-mountain-background_188544-9126.jpg'},
  //   {img: 'https://img.freepik.com/free-photo/painting-mountain-lake-with-mountain-background_188544-9126.jpg'},*/
  // ];
  @ViewChildren('infoWindow') infoWindowList :QueryList<MapInfoWindow>;
  @ViewChildren('alarmMarker') alarmMarkerList :QueryList<MapMarker>;
  @ViewChildren('alarmTooltip', {read: ElementRef}) alarmTooltipList :QueryList<ElementRef<HTMLElement>>;
  private customIconPath = 'assets/images/misc/';
  public customIconZoom = 13;
  public customIconCenter: google.maps.LatLngLiteral = { lat: 37.421995, lng: -122.084092 };
  public customIcon2Center: google.maps.LatLngLiteral = { lat: 37.431997, lng: -122.094097 };
  customIcon2Options = {
    icon: this.customIconPath + 'leaf-green.png'
  };
  customIconOptions = {
    icon: this.customIconPath + 'leaf-red.png'
  };

  @ViewChild(GoogleMap) map!: GoogleMap;


  modalData: any;
  firstLoad: boolean = true;
  private closedSlides: any[] = [];
  private closedInfoWindows: any[] = [];
  private automaticallyOpenedInfoWindowIds = new Set<string>();
  /** zIndex creciente para el recuadro que se trae al frente. */
  private infoWindowZIndex = 1000;
  /** Consulta de alarmas del último setLocations; se cancela al llegar otra para que una
   *  respuesta antigua no reemplace pines más recientes. */
  private alarmInfoSubscription: Subscription | null = null;
  /** Última posición válida de cada pin: si una actualización llega sin coordenadas
   *  (GPS vacío momentáneamente), el pin se mantiene en su lugar en vez de desaparecer. */
  private lastMarkerPositions = new Map<string, google.maps.LatLngLiteral>();
  private tooltipConnectorAnimationFrame: number | null = null;
  private tooltipConnectorMeasurementFrame: number | null = null;
  private tooltipConnectorMeasurementSecondFrame: number | null = null;
  private tooltipConnectorZoom: number | null = null;
  private tooltipConnectorForceUpdate = false;
  private tooltipConnectorSettleFrames = 0;
  private tooltipResizeObserver: ResizeObserver | null = null;
  tooltipMapMoving = false;
  alarmTestIteration: number = 0;

  constructor(
    private installationService: InstallationService,
    private alarmService: AlarmService,
    private router: Router,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
  ) {
  }
  async ngOnChanges(changes: SimpleChanges) {
    if (this.destroyed) return;
    console.log("NG CHANGES INSTALLATION");console.dir(changes);
    if(changes['hideGoogleMapControls']){
      this.configureMapControls();
    }
    if(changes['installationList']){
      const cInstallationList = changes['installationList'].currentValue;
      this.installationList_ = Array.isArray(cInstallationList)
        ? cInstallationList
        : (cInstallationList ? [cInstallationList] : []);
      this.installationList_ = this.installationList_.filter(installation =>
        Array.isArray(installation && installation.Locations) &&
        installation.Locations.some(location => location.status_id == 1)
      );
      this.installations$.next(this.installationList_);
    }
    if(changes['alarmList'] && !changes['installationList'] && this.installationList_ && this.installationList_.length){
      // Una lista proporcionada por el padre es autoritativa, incluida una lista vacía.
      this.installations$.next(this.installationList_);
    }
    if(changes['locationId']){
      const locationId = changes['locationId'].currentValue;
      if(!_.isNil(locationId)){
        this.panToLocationId(locationId);
      }
    }
    if(changes['installationId']){
      const installationId = changes['installationId'].currentValue;
      if(!_.isNil(installationId)){
        this.panToInstallation(installationId);
      }
    }
    if(changes['alarm']){
      const alarm = changes['alarm'].currentValue;
      console.log("testa alarm change ", alarm)
      if(!_.isNil(alarm)){
        this.panToAlarm(alarm);
      }
    }
  }

  async ngOnInit(){
    if (this.destroyed) return;
    this.configureMapControls();

    if(this.installationList){
      let installationList: any[] = this.installationList;
      if(this.installationList.length == undefined){
        installationList = [this.installationList];
      }
      this.installationList_ = installationList;
      console.log("INSTALLATION LIST AS INPUT -> SET LOCATIONS")
      this.installations$.next(installationList);

    }else{

      this.subscriptions.push(
        interval(5000).pipe(
          startWith(0),
          switchMap(()=>this.installationService.getAll())
        ).subscribe((installationList)=>{
          console.log('MARK1')
          console.dir(installationList);
          this.installationList_ = (installationList || []).filter(installation =>
            Array.isArray(installation && installation.Locations) &&
            installation.Locations.some(location => location.status_id == 1)
          );
          
          // if(this.installationList_.some(installation=>installation.installation_type_id != 5)){
            // this.scheduledWorksEnabled = true
            // }
          
          this.installations$.next(this.installationList_);
        })
      )
    }
    this.mapMode = 'satellite';
    console.log("ng on init map mode: " +this.mapMode)
    // this.toggleMapMode();
    // setTimeout(()=>this.toggleMapMode(), 200);
    // interval(500).subscribe(()=>{
    //   console.log(`mapas.page.ts map mode: ${this.mapMode}`)
    // })

    this.subscriptions.push(
      this.installations$.pipe(
        filter(installationList=>installationList!=null),
        // Cada actualización de instalaciones debe dibujar el mapa inmediatamente.
        // Las alarmas reales se aplican después cuando el observable las publique.
        switchMap(()=>this.alarmList
          ? of(this.alarmList)
          : this.alarmService.alarms$.pipe(startWith([]))),
        filter(alarms=>alarms!=null ),
        filter((alarms)=>this.installationList_!=null)
      ).subscribe((alarmList)=>{
        const locationList = this.getVisibleLocations(this.installationList_)
        console.dir(locationList)
        // this.setLocations(locationList)
        // const locationList = _.flatten(this.installationList_
        //   .map(installation=>installation.Locations));
        locationList.forEach(location=>{
          if(location.location_type_id == 3){
            //En caso de haber definido una lista de alarmas se guia por si existe una alarma para la zona
            const locationAlarms = alarmList.filter(alarm => this.getAlarmLocationId(alarm) === Number(location.id));
            if(this.getMarkerStatusId(location, locationAlarms) === 4){
              console.log("ALARM LIST NOT AS INPUT")
              //tipo zona con alarma
              location['stroke-color'] = '#bf0202'
              console.log(`SE ENCUENTRA ALARMA EN UNA ZONA ${location.name}: `);console.dir(alarmList.find(alarm=>this.getAlarmLocationId(alarm) === Number(location.id)))
            }else{
              location['stroke-color'] = this.getLocationColor(location);
            }
          }else{
            delete location['stroke-color']
          }
        })
        // this.lastLocations = locationList;
        this.setLocations(locationList);
        //TEST ACTUALIZACIÓN DE MAPA
        // setTimeout(()=>{
        //   const location = locationList.find(location=>location.id==35); //infra 7
        //   location['stroke-color'] = '#bf0202';
        //   this.setLocations(locationList);
        // }, 1000*10)
    }));

  }

  private configureMapControls(): void {
    this.mapOptions = this.hideGoogleMapControls
      ? {
          ...mapOptions,
          disableDefaultUI: true,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: false
        }
      : {...mapOptions};
  }

  /**
   * Programa una tarea que se invalida automáticamente cuando el componente
   * es destruido. Los overlays de Google Maps suelen aplicar sus cambios en
   * un frame posterior al de Angular, por lo que un setTimeout sin limpiar
   * puede volver a escribir geometría sobre un mapa de otra ruta.
   */
  private scheduleTimeout(callback: () => void, delay = 0): ReturnType<typeof setTimeout> {
    const timeoutId = setTimeout(() => {
      this.pendingTimeouts.delete(timeoutId);
      if (this.destroyed) return;
      callback();
    }, delay);
    this.pendingTimeouts.add(timeoutId);
    return timeoutId;
  }

  /** Indica si el mapa todavía pertenece al documento actual. */
  private hasAttachedMap(): boolean {
    if (this.destroyed || !this.map || !this.map.googleMap) return false;
    const mapDiv = this.map.googleMap.getDiv && this.map.googleMap.getDiv();
    if (!mapDiv) return false;
    return mapDiv.isConnected !== false;
  }

  /** Evita calcular coordenadas cuando el contenedor está oculto o ya salió
   *  del DOM durante una navegación. En ese estado la proyección de Google
   *  Maps no representa la posición visual de los overlays. */
  private hasMeasurableMap(): boolean {
    if (!this.hasAttachedMap()) return false;
    const mapRect = this.map.googleMap.getDiv().getBoundingClientRect();
    return mapRect.width > 0 && mapRect.height > 0;
  }

  statusMap = {
    1:	'APAGADO',
    2:	'ARMADO',
    3:	'DES-ARMADO',
    4:	'ALARMADO',
    5:	'BLOQUEADO',
  }

  addMapLegends(){
    this.subscriptions.push(
      interval(100).pipe(
        filter(()=>this.map!=undefined),
        take(1)
      ).subscribe(()=>{
        var legend = document.getElementById('mapLegend');
        this.map.controls[google.maps.ControlPosition.LEFT_TOP].push(legend);
        this.scheduleTimeout(()=>{
          this.mapLegendLoaded = true;
        }, 1500)
      })
    )
  }
  
  getVisibleLocations(installationList){
    return _.flatten((installationList || [])
      .map(installation=>(installation.Locations || []).map(location => ({
        ...location,
        // Conserva la relación de siac_location con siac_installation para el modal.
        Installation: location.Installation || installation,
        installation: location.installation || installation,
        installation_name: location.installation_name || installation.name
      }))))
      .filter(location=>location.status_id==1);
  }

  getLocationColor(location){
    console.log("COLOR BY SIAC STATUS ID: ")

    /*Bloqueado →azul (siac_status_id = 5)
  Armado → verde (siac_status_id = 2)
  Des-armado → amarillo(siac_status_id = 3)
  Alarmado → rojo (siac_status_id = 4)
  Apagado → gris (siac_status_id = 1)*/
 /* public colors = [
      { name: 'Bloqueado', hex: '#140bbf' },
      { name: 'Armado', hex: '#0B986A' },
      { name: 'Des-armado', hex: '#FAD92A' },
      { name: 'Alarmado', hex: '#F51E1E' },
      { name: 'Apagado', hex: '#4A4949' }
    ]*/
    const colorMap: {[siac_status_id: number]: string} = {
      1: '#4A4949',
      2: '#0B986A',
      3: '#FAD92A',
      4: '#F51E1E',
      5: '#140bbf'
    }
    // if(this.markersLoaded == false)return '#32a852'
    if(this.zoneColorByLatestStatus)
      return colorMap[location.siac_status_id];
    else
      return '#0B986A'
  }

  ngAfterViewInit(): void {
    if (this.destroyed) return;
    if (this.showFullscreenButton) this.addFullScreenButton();
    this.addCam();
    this.addlistAlarm();
    if(this.showLegend)
      this.addMapLegends();
    if (typeof ResizeObserver !== 'undefined') {
      this.tooltipResizeObserver = new ResizeObserver(() => {
        if (!this.destroyed) this.settleTooltipConnectors(4);
      });
      this.subscriptions.push(this.alarmTooltipList.changes.subscribe(() => {
        this.observeAlarmTooltips();
        this.settleTooltipConnectors();
      }));
      this.observeAlarmTooltips();
    }
  }
  
  getBounds(markers){
    let north;
    let south;
    let east;
    let west;
  
    for (const marker of markers){
      // set the coordinates to marker's lat and lng on the first run.
      // if the coordinates exist, get max or min depends on the coordinates.
      north = north !== undefined ? Math.max(north, marker.position.lat) : marker.position.lat;
      south = south !== undefined ? Math.min(south, marker.position.lat) : marker.position.lat;
      east = east !== undefined ? Math.max(east, marker.position.lng) : marker.position.lng;
      west = west !== undefined ? Math.min(west, marker.position.lng) : marker.position.lng;
    }
  
    const bounds = { north, south, east, west };
  
    return bounds;
  }

  // private basePoint = {google_lat: -33.355200​, google_lng: -70.742600}

  // private randomPointAround(radiusMeters: number) {
  //   const earthRadius = 6378137; // metros

  //   const distance = Math.sqrt(Math.random()) * radiusMeters;
  //   const bearing = Math.random() * 2 * Math.PI;

  //   const deltaLat = (distance * Math.cos(bearing)) / earthRadius;
  //   const deltaLng =
  //     (distance * Math.sin(bearing)) /
  //     (earthRadius * Math.cos(this.basePoint.google_lat * Math.PI / 180));

  //   return {
  //     lat: this.basePoint.google_lat + deltaLat * 180 / Math.PI,
  //     lng: this.basePoint.google_lng + deltaLng * 180 / Math.PI
  //   };
  // }

  // private lastLocations: any[] = [];
  // setLocations(locationList: any[] = []){
  //   return this.setLocationsPerDevice(locationList);
  // }

  // private setLocationsLegacy(locationList){
  //   console.log("LOCATION LIST ", locationList);
  //   locationList.forEach(location => {
  //     const lastLocation = this.lastLocations.find(l => l.id == location.id);
  //     if(_.get(lastLocation, 'stroke-color')) location['stroke-color'] = lastLocation['stroke-color']
  //   });
  //   // this.markersLoaded = false;
  //   const polyLines = []
  //   const markers = [];
  //   const infoWindows = []
  //   let deviceList = [];
  //   const alarmInfo$ = this.alarmList !== null
  //     ? this.todayAlarmsAndMapInfo(this.alarmList)
  //     : this.todayAlarmsAndMapInfo();
  //   alarmInfo$.subscribe(alarmsAndMapInfo=>{
  //     console.log("alarms and map info: ", alarmsAndMapInfo);
  //     const alarms: any[] = alarmsAndMapInfo.alarmList;
  //     const slidesByDevice = alarmsAndMapInfo.slides;
  //     console.log("SLIDES BY DEVICE: ", slidesByDevice)
  //     locationList.forEach(location=>{
  //       if(Number(location.google_lat) === 0 || Number(location.google_lng) === 0) return;
  //       deviceList = deviceList.concat(location.Devices || []);
  //       const locationAlarms = alarms.filter(alarm => this.getAlarmLocationId(alarm) === Number(location.id));
  //       // El mapa nuevo puede recibir alarmas activas antiguas. Se conservan
  //       // para el estado del pin, pero no se usan para abrir InfoBox.
  //       const infoWindowAlarms = this.getRecentInfoWindowAlarms(locationAlarms);
  //       // ZONAS (location_type_id = 3): línea geográfica, marcador y gráfico de alarmas.
  //       if(location.location_type_id == 3){
  //         if(Number(location.google_lat1) === 0 || Number(location.google_lng1) === 0
  //           || Number(location.google_lat2) === 0 || Number(location.google_lng2) === 0) return;
  //         const polyLine = {
  //           path: [
  //             {
  //               lat: Number(location.google_lat1),
  //               lng: Number(location.google_lng1),
  //             },
  //             {
  //               lat: Number(location.google_lat2),
  //               lng: Number(location.google_lng2)
  //             }
  //           ],
  //           location_id: location.id,
  //           installation_id: location.installation_id,
  //           alarmList: infoWindowAlarms,
  //           strokeWeight: '2',
  //           visible: true,
  //           strokeColor: location['stroke-color'] || this.getLocationColor(location),
  //           strokeOpacity: 0.8,
  //           onclick: ()=>{
  //             console.log("path clicked => location: ");console.dir(location);
  //             this.openZoneModal(location);
  //           }
  //         }
  //         polyLines.push(polyLine)

  //         const marker = {
  //           position: {
  //             lat: Number(location.google_lat),
  //             lng: Number(location.google_lng),
  //           },
  //           // position: { lat: -33.4166668, lng: -70.6092060 }, title: 'Marker 2',
  //           visible: true,
  //           location_type_id: 3,
  //           location_id: location.id,
  //           installation_id: location.installation_id,
  //           location: location,
  //           alarmList: infoWindowAlarms,
  //           title: location.name,
  //           label: { color: '#ffffff', text: location.name, fontSize: '14px', fontWeight: '700', className: 'siac-map-marker-label'},
  //           onclick: ()=>{
  //             this.locationClicked(location);
  //           },
  //           infoWindow: {
  //             position: {
  //               lat: Number(location.google_lat),
  //               lng: Number(location.google_lng),
  //             },
  //             visible: true,
  //           },
  //           // icon: null
  //           icon: { url: '', scaledSize: { width: 0, height: 0 }, labelOrigin: { x: 0, y: 0 } },
  //           // info: { contenido: 'Marker info window content', title: location.name, accion: 'console.log("hola")' },
  //         }
  //         if(this.locationInfoWindowClosed(location) || !infoWindowAlarms.length){
  //           delete marker['infoWindow']
  //         }
  //         markers.push(marker);
  //         // delete marker['position']
  //       // CÁMARAS (location_type_id = 7): marcador y capturas asociadas a alarmas.
  //       }else if(location.location_type_id==7){
  //         const locationDevices = location.Devices || [];
  //         const recentAlarmDeviceIds = new Set(infoWindowAlarms.map(alarm =>
  //           Number(alarm.device_id || _.get(alarm, 'Device.id'))
  //         ));
  //         const slides = _.flattenDeep(_.values(_.omitBy(
  //           locationDevices
  //             .filter(device => recentAlarmDeviceIds.has(Number(device.id)))
  //             .map(d => slidesByDevice[Number(d.id)]),
  //           _.isNil
  //         )));
  //         console.log(`slides devices ${JSON.stringify(locationDevices.map(d=>d.id))}: `, {
  //           slides,
  //           slidesByDevice,
  //         });
  //         const marker = {
  //           position: {
  //             lat: Number(location.google_lat),
  //             lng: Number(location.google_lng),
  //           },
  //           // position: { lat: -33.4166668, lng: -70.6092060 }, title: 'Marker 2',
  //           visible: true,
  //           location_type_id: 7,
  //           installation_id: location.installation_id,
  //           location_id: location.id,
  //           location: location,
  //           alarmList: infoWindowAlarms,
  //           title: location.name,
  //           label: { color: '#ffffff', text: location.name, fontSize: '10px', fontWeight: '700', className: 'siac-map-marker-label'},
  //           icon: { url: this.getLocationImageUrl(location, locationAlarms), scaledSize: { width: 40, height: 40 }, labelOrigin: { x: 20, y: -10 } },
  //           onclick: ()=>{
  //             this.locationClicked(location);
  //           },
  //           // info: { contenido: 'Marker info window content', title: location.name, accion: 'console.log("hola")' },
  //           infoWindow: {
  //             slides: slides,
  //             position: {
  //               lat: Number(location.google_lat),
  //               lng: Number(location.google_lng),
  //             },
  //             visible: true,
  //           }
  //         }
  //         if(((_.isNil(slides) || _.isEmpty(slides)) && (!this.hideGoogleMapControls || !infoWindowAlarms.length)) || this.locationInfoWindowClosed(location)){
  //           delete marker['infoWindow']
  //         }
  //         markers.push(marker);
  //         /*infoWindows.push({
  //           slides: this.slides,
  //           position: {
  //             lat: Number(location.google_lat),
  //             lng: Number(location.google_lng),
  //           },
  //           visible: true,
  //         })*/

  //       // TRANSFORMADORES, CAMIONETAS Y PALAS (4, 8, 9): marcador y gráfico de alarmas.
  //       }else if([4, 8, 9].includes(location.location_type_id)){
  //         // const randPos = this.randomPointAround(5)
  //         const marker = {
  //           position: {
  //             lat: Number(location.google_lat),
  //             lng: Number(location.google_lng),
  //           },
  //           // position: { lat: -33.4166668, lng: -70.6092060 }, title: 'Marker 2',
  //           visible: true,
  //           location_type_id: location.location_type_id,
  //           location: location,
  //           location_id: location.id,
  //           installation_id: location.installation_id,
  //           alarmList: infoWindowAlarms,
  //           title: location.name,
  //           label: { color: '#ffffff', text: location.name, fontSize: '10px', fontWeight: '700', className: 'siac-map-marker-label'},
  //           // label: { color: 'red', text: location.name, fontSize: '14px'},
  //           onclick: ()=>{
  //             this.locationClicked(location);
  //           },
  //           infoWindow: {
  //             position: {
  //               lat: Number(location.google_lat),
  //               lng: Number(location.google_lng),
  //             },
  //             visible: true,
  //             // Desplaza el gráfico hacia arriba para no tapar el marcador.
  //             pixelOffset: new google.maps.Size(0, -55)
  //           },
  //           // icon: null
  //           // icon: { url: '', scaledSize: { width: 0, height: 0 }, labelOrigin: { x: 0, y: 0 } },
  //           icon: { url: this.getLocationImageUrl(location, locationAlarms), scaledSize: { width: 40, height: 40 }, labelOrigin: { x: 20, y: -10 } },
  //           // info: { contenido: 'Marker info window content', title: location.name, accion: 'console.log("hola")' },
  //         }
  //         if(this.locationInfoWindowClosed(location) || !infoWindowAlarms.length){
  //           delete marker['infoWindow']
  //         }
  //         markers.push(marker);
  //         // delete marker['position']
  //       // SENSORES, GATEWAYS, RELAYS Y TIPOS RESTANTES: marcador y resumen de alarma.
  //       }else{
  //         const marker = {
  //           position: {
  //             lat: Number(location.google_lat),
  //             lng: Number(location.google_lng),
  //           },
  //           // position: { lat: -33.4166668, lng: -70.6092060 }, title: 'Marker 2',
  //           visible: true,
  //           location_type_id: location.location_type_id,
  //           installation_id: location.installation_id,
  //           location_id: location.id,
  //           location: location,
  //           alarmList: infoWindowAlarms,
  //           title: location.name,
  //           label: { color: '#ffffff', text: location.name, fontSize: '10px', fontWeight: '700', className: 'siac-map-marker-label'},
  //           icon: { url: this.getLocationImageUrl(location, locationAlarms), scaledSize: { width: 40, height: 40 }, labelOrigin: { x: 20, y: -10 } },
  //           onclick: ()=>{
  //             this.locationClicked(location);
  //           },
  //           infoWindow: {
  //             position: {
  //               lat: Number(location.google_lat),
  //               lng: Number(location.google_lng),
  //             },
  //             visible: true,
  //             pixelOffset: new google.maps.Size(0, -55)
  //           }
  //           // info: { contenido: 'Marker info window content', title: location.name, accion: 'console.log("hola")' },
  //         }
  //         if(!this.hideGoogleMapControls || this.locationInfoWindowClosed(location) || !infoWindowAlarms.length){
  //           delete marker['infoWindow'];
  //         }
  //         markers.push(marker);
  //       }
  //     });
  //     if(this.firstLoad && markers && markers.length>0){
  //       this.markerCirclePolygonCenter.lat = markers[0].position.lat;
  //       this.markerCirclePolygonCenter.lng = markers[0].position.lng;
  //     }
  //     this.separateNearbyInfoWindows(markers);
  //     this.markers = this.reconcileMarkers(markers);
  //     this.polyLines = this.reconcilePolyLines(polyLines);
  //     this.infoWindows = Array.from(infoWindows);
  //     console.log("map elements: ", {
  //       markers,
  //       polyLines,
  //       infoWindows
  //     })
  //     /*console.dir(this.markers);
  //     console.dir(this.polyLines)*/
  //     this.deviceList = deviceList;
  //     const initialRender = !this.markersLoaded;
  //     this.markersLoaded = true;
  //     this.cdr.detectChanges();
  //     this.queueTooltipConnectorMeasurement();
  //     // Las alarmas suelen llegar después de las instalaciones. Se revisan las
  //     // ventanas en cada actualización, pero cada ubicación se abre una sola vez.
  //     setTimeout(() => this.openAutomaticAlarmInfoWindows(), 0);

  //     // Ajustar límites y abrir ventanas sólo cuando el mapa se monta por primera vez.
  //     // Repetir estas operaciones en cada sondeo provoca movimientos y parpadeos visibles.
  //     if(initialRender){
  //       setTimeout(()=>{
  //         if(this.markers.length > 0) this.setInitialBounds();
  //         this.firstLoad = false;
  //         this.cdr.detectChanges();
  //       }, 500);
  //     }
  //   })
  // }

  /**
   * Construye los marcadores usando la posición GPS actual del dispositivo.
   * La clave estable por dispositivo permite que Google Maps conserve cada
   * overlay mientras cambia la coordenada o se actualizan las alarmas.
   */
  setLocations(locationList: any[] = []): void {
    if (this.destroyed) return;
    // Durante una navegación Angular puede retirar el host un instante antes
    // de ejecutar ngOnDestroy. No reemplazar los overlays en esa ventana evita
    // que una respuesta tardía los deje asociados al mapa anterior.
    if (this.markersLoaded && !this.hasAttachedMap()) return;
    const locations = Array.isArray(locationList) ? locationList : [];
    const polyLines: any[] = [];
    const markers: any[] = [];
    // const infoWindows: any[] = [];
    // let deviceList: any[] = [];
    const alarmInfo$ = this.alarmList !== null
      ? this.todayAlarmsAndMapInfo(this.alarmList)
      : this.todayAlarmsAndMapInfo();

    if (this.alarmInfoSubscription) this.alarmInfoSubscription.unsubscribe();
    this.alarmInfoSubscription = alarmInfo$.subscribe(alarmsAndMapInfo => {
      if (this.destroyed) return;
      const alarms: any[] = alarmsAndMapInfo && alarmsAndMapInfo.alarmList || [];
      const slidesByDevice: any = alarmsAndMapInfo && alarmsAndMapInfo.slides || {};

      locations.forEach(location => {
        const locationTypeId = Number(location && location.location_type_id);
        const locationAlarms = alarms.filter(alarm =>
          this.getAlarmLocationId(alarm) === Number(location && location.id)
        );
        const devices = this.getLocationDevices(location);
        // deviceList = deviceList.concat(devices);

        // Las zonas conservan sus líneas configuradas, aunque la posición del
        // pin de un dispositivo provenga del GPS actual.
        if (locationTypeId === 3) {
          const lineStart = this.toMapPosition(location.google_lat1, location.google_lng1);
          const lineEnd = this.toMapPosition(location.google_lat2, location.google_lng2);
          if (lineStart && lineEnd) {
            polyLines.push({
              path: [lineStart, lineEnd],
              location_id: location.id,
              installation_id: location.installation_id,
              alarmList: this.getRecentInfoWindowAlarms(locationAlarms),
              strokeWeight: '2',
              visible: true,
              strokeColor: location['stroke-color'] || this.getLocationColor(location),
              strokeOpacity: 0.8,
              onclick: () => this.openZoneModal(location)
            });
          }
        }

        // Las ubicaciones sin dispositivos mantienen un único pin propio.
        const markerDevices: any[] = devices.length ? devices : [null];
        markerDevices.forEach(device => {
          const markerKey = this.getMarkerKey(location, device);
          const position = this.resolveMapPosition(location, device) || this.lastMarkerPositions.get(markerKey);
          if (!position) return;
          this.lastMarkerPositions.set(markerKey, position);

          // Para un pin de dispositivo la relación autoritativa es device_id;
          // no se exige que la respuesta también expanda Device.location_id.
          const deviceAlarms = device
            ? this.getDeviceAlarmList(alarms, device)
            : locationAlarms;
          // En el mapa nuevo sólo las alarmas de las últimas 24 h abren una
          // tarjeta; deviceAlarms se conserva para colorear correctamente el pin.
          const infoWindowAlarms = this.getRecentInfoWindowAlarms(deviceAlarms);
          const title = this.getDeviceLabel(location, device);
          const isCamera = locationTypeId === 7;
          const hasAlarmChart = locationTypeId === 3 || [4, 8, 9].includes(locationTypeId);
          const marker: any = {
            markerKey,
            device_id: device ? Number(device.id) : null,
            device,
            position,
            visible: true,
            location_type_id: locationTypeId,
            installation_id: location.installation_id,
            location_id: location.id,
            location,
            alarmList: infoWindowAlarms,
            title,
            label: {
              color: '#ffffff',
              text: title,
              fontSize: locationTypeId === 3 && !device ? '14px' : '10px',
              fontWeight: '700',
              className: 'siac-map-marker-label'
            },
            onclick: () => this.locationClicked(location, device)
          };
          // Valores propios del pin; applyOverlapLayout los reemplaza al agrupar o separar.
          marker.realPosition = position;
          marker.baseLabel = marker.label;
          marker.baseTitle = title;
          marker.baseOnclick = marker.onclick;

          if (locationTypeId === 3 && !device) {
            marker.icon = {
              url: '',
              scaledSize: {width: 0, height: 0},
              labelOrigin: {x: 0, y: 0}
            };
            marker.infoWindow = {position, visible: true};
            if (this.locationInfoWindowClosed(location) || !infoWindowAlarms.length) {
              delete marker.infoWindow;
            }
          } else if (isCamera) {
            const slides = device
              ? (slidesByDevice[Number(device.id)] || [])
              : _.flattenDeep(infoWindowAlarms.map(alarm =>
                slidesByDevice[this.getAlarmDeviceId(alarm)] || []
              ));
            marker.icon = {
              url: this.getLocationImageUrl(location, deviceAlarms, device),
              scaledSize: {width: 40, height: 40},
              labelOrigin: {x: 20, y: -10}
            };
            marker.infoWindow = {slides, position, visible: true};
            if (((_.isNil(slides) || _.isEmpty(slides)) &&
              (!this.hideGoogleMapControls || !infoWindowAlarms.length)) ||
              this.locationInfoWindowClosed(location, device)) {
              delete marker.infoWindow;
            }
          } else if (hasAlarmChart) {
            marker.icon = {
              url: this.getLocationImageUrl(location, deviceAlarms, device),
              scaledSize: {width: 40, height: 40},
              labelOrigin: {x: 20, y: -10}
            };
            marker.infoWindow = {
              position,
              visible: true,
              pixelOffset: new google.maps.Size(0, -55)
            };
            if (this.locationInfoWindowClosed(location, device) || !infoWindowAlarms.length) {
              delete marker.infoWindow;
            }
          } else {
            marker.icon = {
              url: this.getLocationImageUrl(location, deviceAlarms, device),
              scaledSize: {width: 40, height: 40},
              labelOrigin: {x: 20, y: -10}
            };
            marker.infoWindow = {
              position,
              visible: true,
              pixelOffset: new google.maps.Size(0, -55)
            };
            if (!this.hideGoogleMapControls || this.locationInfoWindowClosed(location, device) ||
              !infoWindowAlarms.length) {
              delete marker.infoWindow;
            }
          }

          marker.baseIcon = marker.icon;
          marker.baseInfoWindow = marker.infoWindow;
          marker.baseAlarmList = infoWindowAlarms;
          markers.push(marker);
        });
      });

      markers.sort((first, second) => String(first.markerKey).localeCompare(String(second.markerKey)));
      if (this.firstLoad && markers.length > 0) {
        this.markerCirclePolygonCenter = {...markers[0].position};
      }
      const laidOutMarkers = this.applyOverlapLayout(markers, this.getCurrentMapZoom());
      this.separateNearbyInfoWindows(laidOutMarkers);
      this.markers = this.reconcileMarkers(laidOutMarkers);
      this.polyLines = this.reconcilePolyLines(polyLines);

      // this.infoWindows = Array.from(infoWindows);
      // this.deviceList = deviceList;

      const initialRender = !this.markersLoaded;
      this.markersLoaded = true;
      if (this.destroyed) return;
      this.cdr.detectChanges();
      this.queueTooltipConnectorMeasurement();
      this.scheduleTimeout(() => this.openAutomaticAlarmInfoWindows(), 0);

      // Ajustar límites sólo al montar el mapa evita que cada sondeo devuelva
      // la vista a la primera ubicación.
      if (initialRender) {
        this.scheduleTimeout(() => {
          if (this.destroyed) return;
          if (this.markers.length > 0) this.setInitialBounds();
          this.firstLoad = false;
          this.cdr.detectChanges();
        }, 500);
      }
    });
  }

  private getLocationDevices(location: any): any[] {
    const devices = location && (Array.isArray(location.Devices) ? location.Devices : location.devices);
    return Array.isArray(devices) ? devices.filter(Boolean) : [];
  }

  private parseMapCoordinate(value: any, minimum: number, maximum: number): number | null {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'string' && value.trim() === '') return null;
    const coordinate = typeof value === 'string' ? Number(value.trim()) : Number(value);
    if (!Number.isFinite(coordinate) || coordinate < minimum || coordinate > maximum) return null;
    return coordinate;
  }

  private toMapPosition(latitudeValue: any, longitudeValue: any): google.maps.LatLngLiteral | null {
    const latitude = this.parseMapCoordinate(latitudeValue, -90, 90);
    const longitude = this.parseMapCoordinate(longitudeValue, -180, 180);
    if (latitude === null || longitude === null || (latitude === 0 && longitude === 0)) return null;
    return {lat: latitude, lng: longitude};
  }

  /**
   * Resuelve la coordenada de un pin: GPS actual, instalación configurada y,
   * finalmente, la ubicación de siac_location.
   */
  private resolveMapPosition(location: any, device: any = null): google.maps.LatLngLiteral | null {
    if (device) {
      const currentPosition = device.PositionCurrent;
      const gpsPosition = this.toMapPosition(currentPosition && currentPosition.google_lat,
        currentPosition && currentPosition.google_lng);
      if (gpsPosition) return gpsPosition;

      // No depende de installation_valid, que solo indica que la instalación fue completada.
      const installationPosition = this.toMapPosition(
        device.installation_latitude,
        device.installation_longitude
      );
      if (installationPosition) return installationPosition;
    }

    return this.toMapPosition(location && location.google_lat, location && location.google_lng);
  }

  private getCurrentMapZoom(): number {
    const zoom = Number(this.map && this.map.googleMap && this.map.googleMap.getZoom());
    return Number.isFinite(zoom) ? zoom : (this.markerCirclePolygonZoom || 15);
  }

  /**
   * Resuelve los pines que comparten coordenada (por ejemplo, varios dispositivos
   * con el mismo GPS). Con zoom menor a OVERLAP_SEPARATE_ZOOM se muestra un único
   * pin con la cantidad de dispositivos que acerca el mapa al hacer clic; desde ese
   * zoom cada pin se ubica en un círculo alrededor del punto real, a una distancia
   * fija en pantalla para que etiquetas y clics no se tapen.
   * Devuelve objetos nuevos solo para los pines que cambian, de modo que Google Maps
   * reciba las nuevas opciones.
   */
  private applyOverlapLayout(markers: any[], zoom: number): any[] {
    const groups = new Map<string, any[]>();
    (markers || []).forEach(marker => {
      const position = marker && (marker.realPosition || marker.position);
      // Las zonas sin dispositivo usan un pin invisible y no participan.
      if (!position || !marker.icon || !marker.icon.url) return;
      const key = `${Number(position.lat).toFixed(6)},${Number(position.lng).toFixed(6)}`;
      groups.set(key, (groups.get(key) || []).concat(marker));
    });

    const layouts = new Map<any, any>();
    groups.forEach(members => {
      if (members.length < 2) return;
      const ordered = members.slice().sort((first, second) =>
        (Number(first.device_id) || 0) - (Number(second.device_id) || 0));
      const center = ordered[0].realPosition || ordered[0].position;

      if (zoom < this.OVERLAP_SEPARATE_ZOOM) {
        // El pin visible es el que tiene recuadro o alarmas, para conservar el color de alerta.
        const primary = ordered.find(marker => marker.baseInfoWindow) ||
          ordered.find(marker => (marker.baseAlarmList || marker.alarmList || []).length) || ordered[0];
        const names = ordered.map(marker => marker.baseTitle || marker.title).filter(Boolean);
        // Un solo recuadro por grupo (en el pin visible) con las alarmas de todos sus
        // dispositivos; los pines ocultos no muestran el suyo, así no quedan apilados.
        const groupAlarms = _.uniqBy(_.flatten(ordered.map(marker =>
          marker.baseAlarmList || marker.alarmList || [])), alarm => alarm && alarm.id);
        ordered.forEach(marker => layouts.set(marker, marker === primary ? {
          position: center,
          visible: true,
          label: {...(marker.baseLabel || marker.label), text: `${ordered.length} dispositivos`},
          title: names.join('\n'),
          onclick: () => this.zoomIntoOverlapGroup(center),
          alarmList: groupAlarms,
          groupDeviceCount: ordered.length
        } : {position: center, visible: false, hideInfoWindow: true}));
        return;
      }

      // Los iconos (40 px) quedan casi juntos para mantenerse cerca del punto real.
      const chord = 44;
      const radius = ordered.length === 2 ? chord / 2 : chord / (2 * Math.sin(Math.PI / ordered.length));
      const centerPoint = this.projectMapPoint(center, zoom);
      ordered.forEach((marker, index) => {
        // Con dos pines quedan a izquierda y derecha del punto real.
        const angle = Math.PI + 2 * Math.PI * index / ordered.length;
        const layout: any = {
          position: this.unprojectMapPoint({
            x: centerPoint.x + radius * Math.cos(angle),
            y: centerPoint.y + radius * Math.sin(angle)
          }, zoom)
        };
        const baseIcon = marker.baseIcon || marker.icon;
        if (ordered.length === 2 && baseIcon && baseIcon.labelOrigin) {
          // Con los iconos tan juntos, cada etiqueta se corre hacia su lado:
          // la izquierda termina en el borde derecho de su icono y la derecha
          // comienza en el borde izquierdo del suyo, así no se superponen.
          const iconWidth = Number(baseIcon.scaledSize && baseIcon.scaledSize.width) || 40;
          const labelWidth = String((marker.baseLabel || marker.label || {}).text || '').length * 6.2;
          layout.icon = {
            ...baseIcon,
            labelOrigin: {
              x: index === 0 ? iconWidth - labelWidth / 2 : labelWidth / 2,
              y: baseIcon.labelOrigin.y
            }
          };
        }
        layouts.set(marker, layout);
      });
    });

    return (markers || []).map(marker => this.withOverlapLayout(marker, layouts.get(marker) || {}));
  }

  private withOverlapLayout(marker: any, layout: any): any {
    if (!marker) return marker;
    const position = layout.position || marker.realPosition || marker.position;
    const visible = layout.visible !== undefined ? layout.visible : true;
    const label = layout.label || marker.baseLabel || marker.label;
    const title = layout.title || marker.baseTitle || marker.title;
    const onclick = layout.onclick || marker.baseOnclick || marker.onclick;
    const icon = layout.icon || marker.baseIcon || marker.icon;
    // El recuadro se oculta en los pines escondidos por el agrupado y vuelve al separarse.
    const baseInfoWindow = marker.baseInfoWindow !== undefined ? marker.baseInfoWindow : marker.infoWindow;
    const infoWindow = layout.hideInfoWindow ? null : (marker.infoWindow || baseInfoWindow);
    const nextAlarmList = layout.alarmList || marker.baseAlarmList || marker.alarmList;
    const alarmList = this.areAlarmListsEqual(marker.alarmList, nextAlarmList) ? marker.alarmList : nextAlarmList;
    const groupDeviceCount = layout.groupDeviceCount || 1;
    const unchanged = marker.position && Number(marker.position.lat) === Number(position.lat) &&
      Number(marker.position.lng) === Number(position.lng) && marker.visible === visible &&
      _.isEqual(marker.label, label) && marker.title === title && marker.onclick === onclick &&
      _.isEqual(marker.icon, icon) && !!marker.infoWindow === !!infoWindow &&
      marker.alarmList === alarmList && (marker.groupDeviceCount || 1) === groupDeviceCount;
    if (unchanged) return marker;
    return {
      ...marker,
      position,
      icon,
      visible,
      label,
      title,
      onclick,
      alarmList,
      groupDeviceCount,
      // El InfoBox de alarma apunta al pin desplazado para que su conector coincida.
      infoWindow: infoWindow ? {...infoWindow, position} : undefined
    };
  }

  private zoomIntoOverlapGroup(position: google.maps.LatLngLiteral): void {
    const googleMap = this.map && this.map.googleMap;
    if (!googleMap) return;
    googleMap.panTo(position);
    googleMap.setZoom(Math.max(this.OVERLAP_SEPARATE_ZOOM, Number(googleMap.getZoom()) || 0));
  }

  /** Reaplica el agrupado o la separación de pines superpuestos al cambiar el zoom. */
  onMapZoomChanged(): void {
    if (this.destroyed) return;
    const nextMarkers = this.applyOverlapLayout(this.markers, this.getCurrentMapZoom());
    if (nextMarkers.some((marker, index) => marker !== this.markers[index])) {
      this.markers = nextMarkers;
      this.separateNearbyInfoWindows(this.markers);
      this.cdr.detectChanges();
      this.scheduleTimeout(() => this.openAutomaticAlarmInfoWindows(), 0);
    }
    this.settleTooltipConnectors();
  }

  private getMarkerKey(location: any, device: any = null): string {
    const deviceId = device && Number(device.id);
    if (Number.isFinite(deviceId) && deviceId > 0) return `device:${deviceId}`;
    return `location:${location && location.id}`;
  }

  private getDeviceLabel(location: any, device: any = null): string {
    if (device) {
      return device.description || device.name || device.device_name ||
        device.internal_code || device.mac || `Dispositivo ${device.id}`;
    }
    return location && (location.name || location.description) || 'Ubicación';
  }

  private getAlarmDeviceId(alarm: any): number | null {
    const rawId = alarm?.device_id ?? _.get(alarm, 'Device.id');
    const deviceId = Number(rawId);
    return Number.isFinite(deviceId) && deviceId > 0 ? deviceId : null;
  }

  private getDeviceAlarmList(locationAlarms: any[] = [], device: any = null): any[] {
    if (!device) return locationAlarms || [];
    const deviceId = Number(device.id);
    if (!Number.isFinite(deviceId) || deviceId <= 0) return [];
    return (locationAlarms || []).filter(alarm => this.getAlarmDeviceId(alarm) === deviceId);
  }

  trackByMarker(index: number, marker: any): number | string {
    return marker.markerKey || this.getMarkerKey(marker.location, marker.device);
  }

  trackByPolyLine(index: number, polyLine: any): number | string {
    return polyLine.location_id;
  }

  trackByTooltipConnector(index: number, connector: any): number | string {
    return connector.id;
  }

  private getAlarmKey(alarm: any): string {
  return [
    alarm.id,
    alarm.create_date,
    alarm.write_date || '',
    alarm.status_id || '',
    alarm.device_id || _.get(alarm, 'Device.id', '')
  ].join('|');
}

private areAlarmListsEqual(
  previousAlarmList: any[] = [],
  nextAlarmList: any[] = []
): boolean {
  if (previousAlarmList === nextAlarmList) {
    return true;
  }

  if (!previousAlarmList || !nextAlarmList) {
    return false;
  }

  if (previousAlarmList.length !== nextAlarmList.length) {
    return false;
  }

  const previousKeys = previousAlarmList
    .map(alarm => this.getAlarmKey(alarm))
    .sort();

  const nextKeys = nextAlarmList
    .map(alarm => this.getAlarmKey(alarm))
    .sort();

  return previousKeys.every(
    (key, index) => key === nextKeys[index]
  );
}

private reconcileMarkers(nextMarkers: any[]): any[] {
  const previousMarkersByKey = new Map<string, any>();

  (this.markers || []).forEach(marker => {
    previousMarkersByKey.set(this.getMarkerKey(marker.location, marker.device), marker);
  });

  return nextMarkers.map(nextMarker => {
    const previousMarker = previousMarkersByKey.get(
      nextMarker.markerKey || this.getMarkerKey(nextMarker.location, nextMarker.device)
    );

    if (!previousMarker) {
      return nextMarker;
    }

    const alarmsDidNotChange = this.areAlarmListsEqual(
      previousMarker.alarmList,
      nextMarker.alarmList
    );

    if (alarmsDidNotChange) {
      nextMarker.alarmList = previousMarker.alarmList;
    }

    if (this.markerVisualStateDidNotChange(previousMarker, nextMarker)) {
      // Los datos auxiliares pueden cambiar sin volver a configurar el pin de Google Maps.
      previousMarker.location = nextMarker.location;
      previousMarker.onclick = nextMarker.onclick;
      previousMarker.alarmList = nextMarker.alarmList;
      previousMarker.device = nextMarker.device;
      previousMarker.device_id = nextMarker.device_id;
      previousMarker.markerKey = nextMarker.markerKey;
      previousMarker.title = nextMarker.title;
      previousMarker.label = nextMarker.label;
      previousMarker.realPosition = nextMarker.realPosition;
      previousMarker.baseLabel = nextMarker.baseLabel;
      previousMarker.baseTitle = nextMarker.baseTitle;
      previousMarker.baseOnclick = nextMarker.baseOnclick;
      previousMarker.baseIcon = nextMarker.baseIcon;
      previousMarker.baseInfoWindow = nextMarker.baseInfoWindow;
      previousMarker.baseAlarmList = nextMarker.baseAlarmList;
      previousMarker.groupDeviceCount = nextMarker.groupDeviceCount;

      if (previousMarker.infoWindow && nextMarker.infoWindow) {
        previousMarker.infoWindow.slides = nextMarker.infoWindow.slides;
      }

      return previousMarker;
    }

    return nextMarker;
  });
}

private markerVisualStateDidNotChange(previousMarker: any, nextMarker: any): boolean {
  return _.isEqual(
    this.getMarkerVisualState(previousMarker),
    this.getMarkerVisualState(nextMarker)
  );
}

private getMarkerVisualState(marker: any): any {
  const infoWindow = marker && marker.infoWindow;
  const pixelOffset = infoWindow && infoWindow.pixelOffset;

  return {
    position: marker && marker.position,
    visible: marker && marker.visible,
    location_type_id: marker && marker.location_type_id,
    installation_id: marker && marker.installation_id,
    title: marker && marker.title,
    label: marker && marker.label,
    icon: marker && marker.icon,
    hasInfoWindow: !!infoWindow,
    infoWindowPosition: infoWindow && infoWindow.position,
    infoWindowPixelOffset: pixelOffset
      ? {width: pixelOffset.width, height: pixelOffset.height}
      : null
  };
}

private reconcilePolyLines(nextPolyLines: any[]): any[] {
  const previousByLocationId = new Map<number, any>();
  (this.polyLines || []).forEach(polyLine => previousByLocationId.set(polyLine.location_id, polyLine));

  return nextPolyLines.map(nextPolyLine => {
    const previousPolyLine = previousByLocationId.get(nextPolyLine.location_id);
    if (!previousPolyLine) return nextPolyLine;

    const visualStateDidNotChange = _.isEqual(
      this.getPolyLineVisualState(previousPolyLine),
      this.getPolyLineVisualState(nextPolyLine)
    );
    if (!visualStateDidNotChange) return nextPolyLine;

    previousPolyLine.onclick = nextPolyLine.onclick;
    previousPolyLine.alarmList = this.areAlarmListsEqual(
      previousPolyLine.alarmList,
      nextPolyLine.alarmList
    ) ? previousPolyLine.alarmList : nextPolyLine.alarmList;
    return previousPolyLine;
  });
}

private getPolyLineVisualState(polyLine: any): any {
  return {
    path: polyLine && polyLine.path,
    visible: polyLine && polyLine.visible,
    strokeWeight: polyLine && polyLine.strokeWeight,
    strokeColor: polyLine && polyLine.strokeColor,
    strokeOpacity: polyLine && polyLine.strokeOpacity
  };
}

  closeInfoWindow(marker, infoWindow){
    if (this.destroyed) return;
    console.log("close info window from marker ", marker)
    if(marker.location_type_id === 7 && Array.isArray(marker.infoWindow && marker.infoWindow.slides)) { //camera
      marker.infoWindow.slides.forEach(slide => {
        this.closedSlides.push(slide);
      });
    }
    this.closedInfoWindows.push(marker);
    const markerKey = marker.markerKey || this.getMarkerKey(marker.location, marker.device);
    this.tooltipConnectors = this.tooltipConnectors.filter(connector =>
      (connector.markerKey || this.getMarkerKey(connector.location, connector.device)) !== markerKey
    );
    if (infoWindow) infoWindow.close();
  }

  private reattachInfoWindowContent(infoWindow: MapInfoWindow): void {
    const nativeInfoWindow = infoWindow && infoWindow.infoWindow;
    const host: HTMLElement = infoWindow && (infoWindow as any)._elementRef && (infoWindow as any)._elementRef.nativeElement;
    if (!nativeInfoWindow || !host || !nativeInfoWindow.get('map')) return;
    if (host.closest('.gm-style-iw')) return;
    host.style.display = '';
    nativeInfoWindow.setContent(host);
  }

  /** Pone el recuadro por encima de los demás (al tocar su pin o la propia tarjeta). */
  bringInfoWindowToFront(infoWindow: MapInfoWindow): void {
    const nativeInfoWindow = infoWindow && infoWindow.infoWindow;
    if (nativeInfoWindow) nativeInfoWindow.setZIndex(++this.infoWindowZIndex);
  }

  /** "Alarma activa", "3 alarmas activas" o, en un grupo, "3 alarmas activas · 2 dispositivos". */
  getMarkerTooltipEyebrow(marker: any): string {
    const alarms = (marker && marker.alarmList || []).length;
    const devices = Number(marker && marker.groupDeviceCount) || 1;
    const alarmText = alarms > 1 ? `${alarms} alarmas activas` : 'Alarma activa';
    return devices > 1 ? `${alarmText} · ${devices} dispositivos` : alarmText;
  }

  /** Nombre del dispositivo o, en un grupo, los nombres de sus dispositivos. */
  getMarkerTooltipTitle(marker: any): string {
    if ((Number(marker && marker.groupDeviceCount) || 1) > 1) {
      return String(marker.title || '').split('\n').filter(Boolean).join(', ');
    }
    return marker && (marker.title || (marker.location && marker.location.name)) || 'Ubicación';
  }

  showAllCameraSlides(){
    this.openAutomaticAlarmInfoWindows();
  }

  private openAutomaticAlarmInfoWindows(): void {
    if (this.destroyed || !this.infoWindowList) return;
    const markersWithInfoWindow = (this.markers || []).filter(marker => !!marker.infoWindow);
    const visibleMarkerKeys = new Set(markersWithInfoWindow.map(marker =>
      marker.markerKey || this.getMarkerKey(marker.location, marker.device)
    ));
    Array.from(this.automaticallyOpenedInfoWindowIds).forEach(markerKey => {
      if (!visibleMarkerKeys.has(String(markerKey))) this.automaticallyOpenedInfoWindowIds.delete(markerKey);
    });

    const windows = this.infoWindowList.toArray();
    const anchors = this.alarmMarkerList ? this.alarmMarkerList.toArray() : [];
    markersWithInfoWindow.forEach((marker, index) => {
      const markerKey = marker.markerKey || this.getMarkerKey(marker.location, marker.device);
      if (windows[index] && this.automaticallyOpenedInfoWindowIds.has(markerKey)) {
        this.reattachInfoWindowContent(windows[index]);
        return;
      }
      if (!windows[index] || this.automaticallyOpenedInfoWindowIds.has(markerKey)) return;
      // El anclaje conserva el pico de Google Maps apuntando al marcador correcto.
      windows[index].open(anchors[index]);
      this.automaticallyOpenedInfoWindowIds.add(markerKey as any);
    });
    // ApexCharts cambia el alto del contenido después de abrir el InfoWindow.
    // Se recalcula al montar y tras su render diferido.
    this.scheduleTimeout(() => this.settleTooltipConnectors(), 0);
    this.scheduleTimeout(() => this.settleTooltipConnectors(4), 180);
  }

  /**
   * Distribuye los tooltips alrededor de su marcador evitando colisiones.
   * La comparación se realiza en píxeles del mundo de Google Maps para que
   * la separación sea proporcional al nivel de zoom actual.
   */
  private separateNearbyInfoWindows(markers: any[]): void {
    if (this.destroyed) return;
    if (!this.hideGoogleMapControls) {
      this.tooltipConnectors = [];
      return;
    }
    // Durante el arrastre Google Maps todavía está aplicando el momentum. Las
    // tarjetas y los polígonos ya siguen sus coordenadas automáticamente; si
    // se recalcula usando el DOM de un frame anterior, el conector puede acabar
    // apuntando a una posición muy lejana.
    // La tarjeta se ancla al pin y Google Maps dibuja su pico (como en satif_apk): sin
    // desplazamientos ni triángulos propios, la tarjeta y el pin no se separan al
    // hacer zoom, arrastrar o actualizar el GPS.
    this.tooltipConnectors = [];
    (markers || []).forEach(marker => {
      if (marker.infoWindow) this.updateMarkerInfoWindowOffset(marker, 0, 0);
    });
    if (this.ANCHORED_TOOLTIPS) return;

    if (this.tooltipMapMoving) return;
    const candidates = (markers || []).filter(marker => marker.infoWindow && marker.position);
    if (!candidates.length) {
      this.tooltipConnectors = [];
      return;
    }

    const zoom = this.map && this.map.googleMap && this.map.googleMap.getZoom()
      || this.markerCirclePolygonZoom
      || 15;
    this.tooltipConnectorZoom = Number(zoom);
    const tooltipGap = 16;
    const markerGap = 18;
    const placedBoxes: Array<{left: number; top: number; right: number; bottom: number}> = [];

    // El orden geográfico evita que el resultado dependa del orden en que la
    // API entregó las alarmas y permite que cada tarjeta conserve la posición
    // libre más cercana a su propio marcador.
    const orderedCandidates = candidates.slice().sort((first, second) => {
      const firstPoint = this.projectMapPoint(first.position, zoom);
      const secondPoint = this.projectMapPoint(second.position, zoom);
      return firstPoint.y - secondPoint.y || firstPoint.x - secondPoint.x;
    });

    orderedCandidates.forEach(marker => {
      const size = this.getTooltipSize(marker);
      const anchor = this.projectMapPoint(marker.position, zoom);
      const placement = this.findNearestTooltipPlacement(
        anchor,
        size,
        placedBoxes,
        tooltipGap,
        markerGap
      );
      placedBoxes.push(placement.box);
      this.updateMarkerInfoWindowOffset(
        marker,
        Math.round(placement.x),
        Math.round(placement.y),
        placement.side
      );
    });

  }

  /**
   * @brief Genera los triángulos después de que Angular y Google Maps hayan
   * aplicado el nuevo pixelOffset y el DOM tenga la posición definitiva.
   * @param {any[]} markers - Marcadores con InfoBox visibles.
   */
  private recalculateTooltipConnectors(markers: any[]): void {
    if (this.ANCHORED_TOOLTIPS) {
      this.tooltipConnectors = [];
      return;
    }
    if (!this.hasMeasurableMap()) {
      this.tooltipConnectors = [];
      return;
    }
    if (!this.hideGoogleMapControls || this.tooltipMapMoving) return;
    const candidates = (markers || []).filter(marker => marker.infoWindow && marker.position);
    if (!candidates.length) {
      this.tooltipConnectors = [];
      return;
    }

    const zoom = this.map && this.map.googleMap && this.map.googleMap.getZoom()
      || this.markerCirclePolygonZoom
      || 15;
    const previousConnectors = new Map<string, any>(
      (this.tooltipConnectors || []).map(connector => [
        connector.markerKey || this.getMarkerKey(connector.location, connector.device),
        connector
      ])
    );
    const nextConnectors = candidates.map(marker => {
      // La línea comienza dentro de la base del tooltip. El solapamiento queda
      // oculto por la tarjeta, pero evita huecos por redondeo o auto-pan del mapa.
      const connectorOverlapPixels = 20;
      const halfBaseWidth = 11;
      const renderedBase = this.getRenderedTooltipBase(marker, zoom, halfBaseWidth);
      let path: google.maps.LatLngLiteral[];
      if (renderedBase) {
        path = [renderedBase[0], renderedBase[1], marker.position];
      } else {
        const offset = marker.infoWindow.pixelOffset || new google.maps.Size(0, -55);
        const markerPoint = this.projectMapPoint(marker.position, zoom);
        const baseCenter = {
          x: markerPoint.x + Number(offset.width || 0),
          y: markerPoint.y + Number(offset.height || 0) - connectorOverlapPixels
        };
        path = [
          this.unprojectMapPoint({x: baseCenter.x - halfBaseWidth, y: baseCenter.y}, zoom),
          this.unprojectMapPoint({x: baseCenter.x + halfBaseWidth, y: baseCenter.y}, zoom),
          marker.position
        ];
      }

      return {
        id: `${marker.markerKey || this.getMarkerKey(marker.location, marker.device)}-triangle`,
        markerKey: marker.markerKey || this.getMarkerKey(marker.location, marker.device),
        location_id: marker.location_id,
        location: marker.location,
        device: marker.device,
        path,
        clickable: false,
        fillColor: '#00e5ff',
        fillOpacity: 0.52,
        strokeColor: '#06131f',
        strokeOpacity: 0.95,
        strokeWeight: 2,
        zIndex: 3
      };
    });
    // El mapa recibe nuevos vértices mientras el zoom está en movimiento.
    // Interpolar cada triángulo evita que su base salte entre dos frames.
    this.tooltipConnectors = nextConnectors.map(connector => {
      const previous = previousConnectors.get(connector.markerKey);
      if (!previous || !Array.isArray(previous.path)) return connector;
      return {
        ...connector,
        path: this.interpolateConnectorPath(previous.path, connector.path, 0.55)
      };
    });
  }

  /**
   * @brief Acerca gradualmente un conector a su nueva geometría.
   * @param {google.maps.LatLngLiteral[]} previousPath - Vértices visibles.
   * @param {google.maps.LatLngLiteral[]} targetPath - Vértices calculados.
   * @param {number} progress - Porción del desplazamiento aplicada en el frame.
   * @returns {google.maps.LatLngLiteral[]} Vértices interpolados.
   */
  private interpolateConnectorPath(
    previousPath: google.maps.LatLngLiteral[],
    targetPath: google.maps.LatLngLiteral[],
    progress: number
  ): google.maps.LatLngLiteral[] {
    if (previousPath.length !== targetPath.length) return targetPath;
    const ratio = Math.max(0, Math.min(1, progress));
    return targetPath.map((target, index) => {
      const previous = previousPath[index];
      return {
        lat: Number(previous.lat) + (Number(target.lat) - Number(previous.lat)) * ratio,
        lng: Number(previous.lng) + (Number(target.lng) - Number(previous.lng)) * ratio
      };
    });
  }

  /**
   * @brief Obtiene el tamaño real del tooltip o una medida segura antes de renderizarlo.
   * @param {any} marker - Marcador cuyo tooltip se va a posicionar.
   * @returns {{width: number; height: number}} Medidas en píxeles.
   */
  private tooltipMatchesMarker(element: HTMLElement, marker: any): boolean {
    const locationId = Number(element.dataset.locationId);
    if (locationId !== Number(marker && marker.location_id)) return false;
    const elementDeviceId = element.dataset.deviceId;
    const markerDeviceId = marker && marker.device_id;
    if ((!elementDeviceId || elementDeviceId === 'null' || elementDeviceId === 'undefined') &&
        (markerDeviceId === null || markerDeviceId === undefined)) {
      return true;
    }
    return Number(elementDeviceId) === Number(markerDeviceId);
  }

  private getTooltipSize(marker: any): {width: number; height: number} {
    const tooltip = this.alarmTooltipList && this.alarmTooltipList.find(item =>
      this.tooltipMatchesMarker(item.nativeElement, marker)
    );
    if (tooltip) {
      const rect = tooltip.nativeElement.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        return {width: rect.width, height: rect.height};
      }
    }

    const locationTypeId = Number(marker.location_type_id);
    const hasChart = [3, 4, 8, 9].includes(locationTypeId);
    return {
      width: locationTypeId === 4 ? 340 : 300,
      height: hasChart ? 290 : 190
    };
  }

  /**
   * @brief Busca la posición libre más cercana al marcador.
   * @param {{x: number; y: number}} anchor - Punto del marcador en píxeles del mundo.
   * @param {{width: number; height: number}} size - Tamaño del tooltip.
   * @param {Array<{left: number; top: number; right: number; bottom: number}>} placedBoxes - Tarjetas ya ubicadas.
   * @param {number} tooltipGap - Separación mínima entre tarjetas.
   * @param {number} markerGap - Separación mínima entre el marcador y la base de una tarjeta superior.
   * @returns {{x: number; y: number; side: 'above' | 'below'; box: {left: number; top: number; right: number; bottom: number}}} Posición elegida.
   */
  private findNearestTooltipPlacement(
    anchor: {x: number; y: number},
    size: {width: number; height: number},
    placedBoxes: Array<{left: number; top: number; right: number; bottom: number}>,
    tooltipGap: number,
    markerGap: number
  ): {x: number; y: number; side: 'above' | 'below'; box: {left: number; top: number; right: number; bottom: number}} {
    const aboveY = -55;
    const candidates: Array<{x: number; y: number; side: 'above' | 'below'; distance: number}> = [];
    const cardRadius = Math.hypot(size.width / 2, size.height / 2) + markerGap;
    const ringStep = Math.max(size.width, size.height) * 0.8 + tooltipGap;
    // Se recorre primero el semicírculo superior, alternando ambos lados para
    // formar un abanico. Las posiciones inferiores quedan como respaldo para
    // no forzar una tarjeta fuera del mapa cuando el grupo es muy numeroso.
    const upperAngles = [-90, -60, -120, -30, -150, 0, 180];
    const lowerAngles = [30, 150, 60, 120, 90];
    const lowerBias = ringStep * 2.5;

    const addCandidate = (
      x: number,
      centerY: number,
      distance: number,
      side: 'above' | 'below'
    ): void => {
      if (side === 'above') {
        // Incluso las posiciones laterales deben mantener toda la tarjeta por
        // encima del marcador, dejando solo una separación pequeña en la base.
        centerY = Math.min(centerY, -size.height / 2 - markerGap);
      }
      const y = centerY + size.height / 2;
      candidates.push({
        x,
        y,
        side,
        distance
      });
    };

    // Mantiene la posición anterior para una tarjeta aislada.
    candidates.push({x: 0, y: aboveY, side: 'above', distance: 0});

    // Se prueban anillos concéntricos crecientes alrededor del marcador. La
    // detección de colisiones decide qué ángulos quedan disponibles para cada
    // tarjeta y termina generando una distribución circular por encima del
    // punto, dejando la parte inferior como último recurso.
    for (let ring = 0; ring <= 10; ring++) {
      const radius = cardRadius + ring * ringStep;
      upperAngles.forEach(angleDegrees => {
        const angle = angleDegrees * Math.PI / 180;
        addCandidate(
          Math.cos(angle) * radius,
          Math.sin(angle) * radius,
          radius,
          'above'
        );
      });
      lowerAngles.forEach(angleDegrees => {
        const angle = angleDegrees * Math.PI / 180;
        addCandidate(
          Math.cos(angle) * radius,
          Math.sin(angle) * radius,
          radius + lowerBias,
          'below'
        );
      });
    }

    candidates.sort((first, second) => first.distance - second.distance);
    for (const candidate of candidates) {
      const box = this.tooltipBox(anchor, candidate, size);
      if (!placedBoxes.some(placed => this.tooltipBoxesOverlap(box, placed, tooltipGap))) {
        return {...candidate, box};
      }
    }

    // Los anillos dejan suficientes posiciones para el mapa normal. Este
    // último desplazamiento mantiene el comportamiento seguro aun con muchas
    // tarjetas en un único punto.
    const fallback = {
      x: 0,
      y: aboveY - (11 * ringStep),
      side: 'above' as const
    };
    return {...fallback, box: this.tooltipBox(anchor, fallback, size)};
  }

  private tooltipBox(
    anchor: {x: number; y: number},
    placement: {x: number; y: number; side: 'above' | 'below'},
    size: {width: number; height: number}
  ): {left: number; top: number; right: number; bottom: number} {
    // pixelOffset.height representa el borde inferior de Google InfoWindow.
    const bottom = anchor.y + placement.y;
    return {
      left: anchor.x + placement.x - size.width / 2,
      top: bottom - size.height,
      right: anchor.x + placement.x + size.width / 2,
      bottom
    };
  }

  private tooltipBoxesOverlap(
    first: {left: number; top: number; right: number; bottom: number},
    second: {left: number; top: number; right: number; bottom: number},
    gap: number
  ): boolean {
    return first.left < second.right + gap && first.right > second.left - gap &&
      first.top < second.bottom + gap && first.bottom > second.top - gap;
  }

  private observeAlarmTooltips(): void {
    if (this.destroyed || !this.tooltipResizeObserver || !this.alarmTooltipList) return;
    this.tooltipResizeObserver.disconnect();
    this.alarmTooltipList.forEach(tooltip => this.tooltipResizeObserver.observe(tooltip.nativeElement));
  }

  private getRenderedTooltipBase(marker: any, zoom: number, halfBaseWidth: number): google.maps.LatLngLiteral[] | null {
    if (!this.alarmTooltipList || !this.map || !this.map.googleMap) return null;
    const tooltip = this.alarmTooltipList.find(item =>
      this.tooltipMatchesMarker(item.nativeElement, marker)
    );
    if (!tooltip) return null;

    const tooltipRect = tooltip.nativeElement.getBoundingClientRect();
    const mapDiv = this.map.googleMap.getDiv();
    const mapRect = mapDiv.getBoundingClientRect();
    if (!tooltipRect.width || !tooltipRect.height || !mapRect.width || !mapRect.height) return null;

    const centerX = tooltipRect.left - mapRect.left + tooltipRect.width / 2;
    // Dos píxeles dentro del borde inferior eliminan cualquier unión visible
    // entre la tarjeta y el triángulo, independientemente de su posición.
    const baseY = tooltipRect.bottom - mapRect.top - 2;
    return [
      this.containerPixelToLatLng(centerX - halfBaseWidth, baseY, zoom, mapRect),
      this.containerPixelToLatLng(centerX + halfBaseWidth, baseY, zoom, mapRect)
    ];
  }

  private containerPixelToLatLng(
    x: number,
    y: number,
    zoom: number,
    mapRect: DOMRect
  ): google.maps.LatLngLiteral {
    const center = this.map.googleMap.getCenter();
    const centerPoint = this.projectMapPoint(center.toJSON(), zoom);
    return this.unprojectMapPoint({
      x: centerPoint.x + x - mapRect.width / 2,
      y: centerPoint.y + y - mapRect.height / 2
    }, zoom);
  }

  /**
   * Reemplaza las opciones del InfoWindow cuando cambia su desplazamiento.
   * Google Maps no detecta de forma fiable una mutación anidada de pixelOffset;
   * la referencia nueva garantiza que la tarjeta y su conector se reposicionen juntos.
   */
  private updateMarkerInfoWindowOffset(
    marker: any,
    width: number,
    height: number,
    placement: 'above' | 'below' = 'above'
  ): void {
    const currentOffset = marker && marker.infoWindow && marker.infoWindow.pixelOffset;
    if (currentOffset && Number(currentOffset.width) === width && Number(currentOffset.height) === height &&
        marker.infoWindow.tooltipPlacement === placement) {
      return;
    }
    marker.infoWindow = {
      ...marker.infoWindow,
      pixelOffset: new google.maps.Size(width, height),
      tooltipPlacement: placement
    };
  }

  /**
   * @brief Desactiva la transición de los InfoBox durante el arrastre del mapa.
   * Los overlays de Google Maps deben seguir el movimiento inercial del mapa
   * sin quedarse atrás mientras los triángulos permanecen anclados.
   */
  onMapDragStart(): void {
    if (this.destroyed) return;
    this.tooltipMapMoving = true;
  }

  /**
   * @brief Mantiene la actualización activa hasta que termine la inercia.
   */
  onMapDragEnd(): void {
    // El evento se dispara al soltar el botón, pero el mapa puede continuar
    // moviéndose por inercia. La actualización se reanuda en onMapIdle().
  }

  /**
   * @brief Reactiva la animación al finalizar el desplazamiento del mapa.
   */
  onMapIdle(): void {
    if (this.destroyed) return;
    this.tooltipMapMoving = false;
    this.settleTooltipConnectors(4);
  }

  /**
   * @brief Espera dos frames antes de medir la base del InfoBox.
   * El primer frame aplica el cambio de Angular y el segundo permite que
   * Google Maps termine de mover el overlay antes de convertirlo a coordenadas.
   */
  private queueTooltipConnectorMeasurement(): void {
    if (!this.hasMeasurableMap() || !this.hideGoogleMapControls || !this.markersLoaded || this.tooltipMapMoving) return;
    if (this.tooltipConnectorMeasurementFrame !== null ||
        this.tooltipConnectorMeasurementSecondFrame !== null) return;

    this.tooltipConnectorMeasurementFrame = requestAnimationFrame(() => {
      this.tooltipConnectorMeasurementFrame = null;
      if (this.destroyed) return;
      this.tooltipConnectorMeasurementSecondFrame = requestAnimationFrame(() => {
        this.tooltipConnectorMeasurementSecondFrame = null;
        if (this.destroyed) return;
        if (this.tooltipMapMoving) return;
        this.recalculateTooltipConnectors(this.markers);
        this.cdr.detectChanges();
      });
    });
  }

  /**
   * Sincroniza los conectores con el zoom en el siguiente frame visual.
   * Así se corrigen inmediatamente después de fitBounds o del zoom manual,
   * sin esperar al siguiente sondeo de alarmas ni recalcular varias veces
   * dentro del mismo frame.
   */
  scheduleTooltipConnectorUpdate(force = false): void {
    if (!this.hasAttachedMap() || !this.hideGoogleMapControls || !this.markersLoaded) return;
    if (this.tooltipMapMoving) return;
    this.tooltipConnectorForceUpdate = this.tooltipConnectorForceUpdate || force;
    if (this.tooltipConnectorAnimationFrame !== null) {
      return;
    }
    this.tooltipConnectorAnimationFrame = requestAnimationFrame(() => {
      this.tooltipConnectorAnimationFrame = null;
      if (!this.hasAttachedMap()) {
        this.tooltipConnectors = [];
        return;
      }
      const forceUpdate = this.tooltipConnectorForceUpdate;
      this.tooltipConnectorForceUpdate = false;
      const currentZoom = Number(this.map && this.map.googleMap && this.map.googleMap.getZoom());
      if (!forceUpdate && Number.isFinite(currentZoom) && this.tooltipConnectorZoom !== null &&
          Math.abs(currentZoom - this.tooltipConnectorZoom) < 0.001) {
        return;
      }
      this.separateNearbyInfoWindows(this.markers);
      this.cdr.detectChanges();
      this.queueTooltipConnectorMeasurement();
      if (this.tooltipConnectorSettleFrames > 0) {
        this.tooltipConnectorSettleFrames--;
        this.scheduleTooltipConnectorUpdate(true);
      }
    });
  }

  /**
   * Sigue la posición real del InfoWindow durante sus cuadros de montaje.
   * Google aplica pixelOffset y auto-pan después del cambio de Angular, por lo
   * que una sola medición puede tomar todavía la posición anterior del bloque.
   */
  settleTooltipConnectors(frames = 6): void {
    if (!this.hasAttachedMap() || !this.hideGoogleMapControls || !this.markersLoaded) return;
    this.tooltipConnectorSettleFrames = Math.max(this.tooltipConnectorSettleFrames, frames);
    this.scheduleTooltipConnectorUpdate(true);
  }

  private projectMapPoint(position: google.maps.LatLngLiteral, zoom: number): {x: number; y: number} {
    const sinLatitude = Math.sin(Number(position.lat) * Math.PI / 180);
    const scale = 256 * Math.pow(2, zoom);
    return {
      x: (Number(position.lng) + 180) / 360 * scale,
      y: (0.5 - Math.log((1 + sinLatitude) / (1 - sinLatitude)) / (4 * Math.PI)) * scale
    };
  }

  private unprojectMapPoint(point: {x: number; y: number}, zoom: number): google.maps.LatLngLiteral {
    const scale = 256 * Math.pow(2, zoom);
    const longitude = point.x / scale * 360 - 180;
    const mercatorY = Math.PI - 2 * Math.PI * point.y / scale;
    const latitude = 180 / Math.PI * Math.atan(Math.sinh(mercatorY));
    return {lat: latitude, lng: longitude};
  }

  /**
   * @brief Selecciona la alarma más reciente asociada al marcador.
   * @param {any} marker - Marcador del mapa con su lista de alarmas.
   * @returns {any} Alarma más reciente o null si no existe.
   */
  getPrimaryMarkerAlarm(marker: any): any {
    return (marker && marker.alarmList || []).slice().sort((a, b) =>
      new Date(b.create_date).getTime() - new Date(a.create_date).getTime()
    )[0] || null;
  }

  /* Métodos de la sección Tipo/Dispositivo, conservados para una futura reactivación.
  getMarkerDeviceName(marker: any): string {
    const alarmDevice = _.get(this.getPrimaryMarkerAlarm(marker), 'Device');
    const locationDevice = _.get(marker, 'location.Devices[0]');
    const device = alarmDevice || locationDevice;
    return _.get(device, 'description') || _.get(device, 'name') || _.get(device, 'mac') || 'Sin dispositivo';
  }

  getMarkerDeviceType(marker: any): string {
    const alarmDevice = _.get(this.getPrimaryMarkerAlarm(marker), 'Device');
    const locationDevice = _.get(marker, 'location.Devices[0]');
    return _.get(alarmDevice || locationDevice, 'DeviceType.name') || this.getLocationTypeLabel(marker && marker.location);
  }
  */

  /**
   * @brief Obtiene el mensaje que se muestra en el InfoBox de alarma.
   * @param {any} marker - Marcador que contiene la alarma activa.
   * @returns {string} Mensaje de la alarma.
   */
  getMarkerAlarmMessage(marker: any): string {
    const alarm = this.getPrimaryMarkerAlarm(marker);
    return _.get(alarm, 'alarm_message') || _.get(alarm, 'AlarmCfg.AlarmType.name') || 'Alarma activa';
  }

  /**
   * @brief Obtiene el sensor origen de la alarma desde la relación de la API.
   * @param {any} marker - Marcador que contiene la alarma activa.
   * @returns {string} Nombre del sensor o "Sin información".
   */
  getMarkerAlarmSensorType(marker: any): string {
    const alarm = this.getPrimaryMarkerAlarm(marker);
    return alarm?.SourceDeviceSensorType?.name || 'Sin información';
  }

  /**
   * @brief Obtiene el tipo de activo desde el dispositivo de la alarma.
   * @param {any} marker - Marcador que contiene la alarma activa.
   * @returns {string} Nombre del activo o "Sin información".
   */
  getMarkerAlarmAssetType(marker: any): string {
    const alarm = this.getPrimaryMarkerAlarm(marker);
    return alarm?.Device?.DeviceType?.name || marker?.device?.DeviceType?.name ||
      marker?.device?.device_type?.name || 'Sin información';
  }

  /**
   * @brief Ajusta la vista del mapa para mostrar todos los marcadores cargados.
   */
  setInitialBounds(){
    if (!this.hasAttachedMap() || !this.markers.length) return;
    const bounds = this.getBounds(this.markers);
    console.log("FIRST LOAD ", bounds)
    this.map.googleMap.fitBounds(bounds);
  }

  /**
   * @brief Filtra las alarmas que pueden abrir un InfoBox en el mapa nuevo.
   * @param {any[]} alarmList - Alarmas asociadas a una ubicación.
   * @returns {any[]} Alarmas creadas durante las últimas 24 horas.
   *
   * El mapa legacy conserva su comportamiento histórico. En el mapa nuevo las
   * alarmas antiguas siguen disponibles para colorear el pin, pero no generan
   * tarjetas, gráficos ni capturas emergentes.
   */
  private getRecentInfoWindowAlarms(alarmList: any[]): any[] {
    if (!this.hideGoogleMapControls) return alarmList || [];

    const now = Date.now();
    const twentyFourHours = 24 * 60 * 60 * 1000;
    return (alarmList || []).filter(alarm => {
      const createdAt = new Date(alarm && alarm.create_date).getTime();
      if (!Number.isFinite(createdAt)) return false;
      const elapsed = now - createdAt;
      return elapsed >= 0 && elapsed <= twentyFourHours;
    });
  }

  /**
   * @brief Consulta las alarmas activas generadas durante el día actual.
   * @returns {Observable<any[]>} Alarmas del día agrupadas para el mapa.
   */
  todayAlarms(){
    const st = new Date();
    if (this.hideGoogleMapControls) {
      st.setTime(st.getTime() - 24 * 60 * 60 * 1000);
    } else {
      st.setHours(0);
      st.setMinutes(0);
      st.setSeconds(0);
    }
    let filterOp = {
      // location_id: this.location.id,
      st: timestamp(st),
      alarm_status_id: 1,
      simple: true
    }
    return this.alarmService.getPage({
      sortField: "id",
      sortOrder: "desc",
      pageSize: 0,
      pageNumber: 0,
      filter: filterOp
    } as any).pipe(
      tap((response) => console.dir(response)),
      filter((response: any) => response && response.items),
      map((response) => response.items),
      map((alarmList)=> {
        return alarmList.sort(function compare(a, b) {
          const dateA = new Date(a.create_date);
          const dateB = new Date(b.create_date);
          return dateA.getTime() - dateB.getTime();
        });
      }),
      tap((todayAlarms)=>console.log("todayAlarms prev: ", todayAlarms)),
    );
  }

  todayAlarmsByDeviceId(todayAlarms = undefined) {
    let todayAlarms$ = of(todayAlarms);
    if(_.isNil(todayAlarms)){
      todayAlarms$ = this.todayAlarms()
    }
    return todayAlarms$.pipe(
      tap((todayAlarms)=>console.log("todayAlarms: ", todayAlarms)),
      map((alarmList)=> _.groupBy(alarmList, alarm => this.getAlarmDeviceId(alarm) || 'unknown'))
    );
  }

  todaySlidesByDeviceId(todayAlarmsByDeviceId = undefined){
    let todayAlarmsByDeviceId$ = of(todayAlarmsByDeviceId);
    if(_.isNil(todayAlarmsByDeviceId)){
      todayAlarmsByDeviceId$ = this.todayAlarmsByDeviceId()
    }
    return todayAlarmsByDeviceId$.pipe(
      tap((todayAlarmsByDeviceId)=>console.log("todayAlarmsByDeviceId: ", todayAlarmsByDeviceId)),
      map((alarmsByDevice)=>{
        console.log("alarms by device: ", alarmsByDevice)
        const slidesByDevice = {};
        for (let deviceId of _.keys(alarmsByDevice)) {
          const alarms = alarmsByDevice[deviceId];
          slidesByDevice[deviceId] = _.flatten(alarms.filter(alarm => alarm.EmailCam)
            .map(alarm => alarm.EmailCam)).map(emailCam => {
            return {
              img: `${GLOBAL_AUTH_SERVER_ADDRESS_SSL}/pics/${emailCam.file_name}`
            }
          })
        }
        return slidesByDevice
      })
    )
  }

  notClosedSlidesByDeviceId(todaySlidesByDeviceId = undefined){
    let todaySlidesByDeviceId$ = of(todaySlidesByDeviceId);
    if(_.isNil(todaySlidesByDeviceId)){
      todaySlidesByDeviceId$ = this.todaySlidesByDeviceId()
    }

    return todaySlidesByDeviceId$.pipe(
      map(slidesByDeviceId=>{
        for(let deviceId of _.keys(slidesByDeviceId)) {
          slidesByDeviceId[deviceId] = slidesByDeviceId[deviceId].filter(slide=>{
            return !this.closedSlides.map(s=>s.img).includes(slide.img)
          });
        }
        return slidesByDeviceId
      })
    )
  }

  todayAlarmsAndMapInfo(providedAlarmList: any[] | null = null){
    const alarmList$ = providedAlarmList !== null ? of(providedAlarmList) : this.todayAlarms();
    return alarmList$.pipe(
      switchMap((alarmList: any[])=> {
        console.log("today alarms inside switchmap ", alarmList)
        const infoWindowAlarmList = this.getRecentInfoWindowAlarms(alarmList);
        if (alarmList && alarmList.length>0) {
          return forkJoin([
            of(alarmList),
            this.todayAlarmsByDeviceId(infoWindowAlarmList).pipe(
              switchMap((alarmsByDeviceId)=>this.todaySlidesByDeviceId(alarmsByDeviceId)),
              switchMap((slidesByDeviceId)=>this.notClosedSlidesByDeviceId(slidesByDeviceId)),
              catchError(error => {
                console.error('No fue posible cargar las imágenes asociadas a las alarmas', error);
                return of({});
              })
            )
          ])
        }
        return of([[], {}]);
      }),
      map(([alarmList, slides])=>{
        console.log("today alarms inside map ", alarmList)
        return {
          alarmList: alarmList as any[],
          slides
        }
      }),
    )
  }

  locationInfoWindowClosed(location, device: any = null){
    const markerKey = this.getMarkerKey(location, device);
    return this.closedInfoWindows.some(marker =>
      (marker.markerKey && marker.markerKey === markerKey) ||
      (!marker.markerKey && Number(marker.location_id) === Number(location && location.id) &&
        (!device || Number(marker.device_id) === Number(device.id)))
    );
  }

  locationClicked(location, device: any = null){
    if (this.selectionMode) {
      this.locationSelected.emit({location, device});
      return;
    }
    // CAMARILLA (1): resumen genérico mientras no exista un modal especializado.
    if(location.location_type_id == 1){
      this.openGenericLocationModal(location, device)
    // SENSORES (2): lecturas actuales del dispositivo.
    }else if(location.location_type_id == 2){
      //abre componente @componente/sensor
      this.openSensorModal(location, device)
    // ZONAS (3): historial y gráfico de alarmas.
    }else if(location.location_type_id == 3){
      //abre modal dashboard src/app/@paginas/variable-history/variable-history.page.html
      this.openZoneModal(location, device);
    // TRANSFORMADORES Y EQUIPOS MÓVILES (4, 8, 9): monitoreo completo del activo.
    }else if([4, 8, 9].includes(location.location_type_id)){
      this.openTransformerModal(location, 'history', undefined, device);
    // GATEWAYS SIAC (5): lecturas actuales.
    }else if(location.location_type_id == 5){
      this.openGWModal(location, device);
    // RELAYS SIAC (6): lecturas actuales.
    }else if(location.location_type_id == 6){
      this.openRelayModal(location, device);
    // CÁMARAS (7): historial y capturas.
    }else if(location.location_type_id == 7){
      this.openCameraModal(location, device);
    }else{
      this.openGenericLocationModal(location, device);
    }
  }

  panToLocationId(locationId, deviceId: number | null = null){
    const marker = this.markers.find(m =>
      Number(m.location_id) === Number(locationId) &&
      (deviceId === null || Number(m.device_id) === Number(deviceId))
    );
    if(marker === undefined) return;
    this.map.googleMap.fitBounds(this.getBounds([marker]));
  }

  panToInstallation(installationId){
    const markers = this.markers.filter(m=>m.installation_id === installationId);
    console.log(`MARKERS INSTALLATION `, {
      markers,
      installationId,
    })
    this.map.googleMap.fitBounds(this.getBounds(markers));
  }

  panToAlarm(alarm){
    console.log("testa panToAlarm ", alarm)
    const locationId = this.getAlarmLocationId(alarm);
    this.panToLocationId(locationId, this.getAlarmDeviceId(alarm));
  }

  /**
   * @brief Obtiene el pin correspondiente al tipo y estado de una ubicación.
   * @param {any} location - Ubicación que se representará en el mapa.
   * @param {any[]} [alarmList] - Alarmas activas asociadas a la ubicación.
   * @returns {string} Ruta del icono coloreado según la leyenda del mapa.
   */
  getLocationImageUrl(location: any, alarmList: any[] = [], device: any = null): string{
    /*
      Por color:
      Bloqueado → café → cambiar a azul (siac_status_id = 5)
      Armado → verde (siac_status_id = 2)
      Des-armado → amarillo → cambiar a gris (siac_status_id = 3)
      Alarmado → rojo (siac_status_id = 4)
      Apagado → blanco (siac_status_id = 1)

      Por Tipo:
      Pin Cámara → siac_location_type = 7
      Se dibuja linea Zona → siac_location_type = 3 (línea y pin por dispositivo asociado)
      Pin estacion solar → SIAC-GW y SIAC-RELAY → siac_location_type =5 y 6
      Pin Pir → SENSOR → siac_location_type = 2
      Pin camarilla → CAMARILLAS → siac_location_type = 1
      Pin movimiento → SENSOR MOVIMIENTO → siac_location_type = 4
    */
    const urlMap: {[siac_status_id:number] : {[location_type_id: number]: string}} = { //siac_status_id=>{[location_type_id:number]: [url: string] }
      5: {//bloqueado
        7: '../../../../../../assets/icons/dash/Vector36.svg', //camara
        1: '../../../../../../assets/icons/dash/Vector37.svg', //CAMARILLA PIN CAMARILLA
        // 4: '../../../../../../assets/icons/dash/Vector38.svg', //SENSOR MOVIMIENTO PIN MOVIMIENTO
        5: '../../../../../../assets/icons/dash/Vector39.svg', //SIAC-GW ESTACION SOLAR
        6: '../../../../../../assets/icons/dash/Vector39.svg', //SIAC-RELAY ESTACION SOLAR
        2: '../../../../../../assets/icons/dash/Vector40.svg', //SENSOR PIN PIR
        3: '../../../../../../assets/icons/dash/Vector40.svg', //DISPOSITIVO ASOCIADO A ZONA
        8: '../../../../../../assets/icons/dash/camioneta-blue.png', //CAMIONETA
        9: '../../../../../../assets/icons/dash/retroescavadora-blue.png', //Pala
        4: '../../../../../../assets/icons/dash/transformador-blue.png', //transformador
      },
      4: {//alarmado
        7: '../../../../../../assets/icons/dash/Vector46.svg', //camara
        1: '../../../../../../assets/icons/dash/Vector47.svg', //CAMARILLA PIN CAMARILLA
        // 4: '../../../../../../assets/icons/dash/Vector48.svg', //SENSOR MOVIMIENTO PIN MOVIMIENTO
        5: '../../../../../../assets/icons/dash/Vector49.svg', //SIAC-GW ESTACION SOLAR
        6: '../../../../../../assets/icons/dash/Vector49.svg', //SIAC-RELAY ESTACION SOLAR
        2: '../../../../../../assets/icons/dash/Vector50.svg', //SENSOR PIN PIR
        3: '../../../../../../assets/icons/dash/Vector50.svg', //DISPOSITIVO ASOCIADO A ZONA
        8: '../../../../../../assets/icons/dash/camioneta-red.png', //CAMIONETA
        9: '../../../../../../assets/icons/dash/retroescavadora-red.png', //Pala
        4: '../../../../../../assets/icons/dash/transformador-red.png', //transformador
      }, //'../../../../../../assets/icons/dash/icon-mapa-1.svg', //alarmado
      3:{//desarmado
        7: '../../../../../../assets/icons/dash/Vector41.svg', //camara
        1: '../../../../../../assets/icons/dash/Vector42.svg', //CAMARILLA PIN CAMARILLA
        // 4: '../../../../../../assets/icons/dash/Vector43.svg', //SENSOR MOVIMIENTO PIN MOVIMIENTO
        5: '../../../../../../assets/icons/dash/Vector44.svg', //SIAC-GW ESTACION SOLAR
        6: '../../../../../../assets/icons/dash/Vector44.svg', //SIAC-RELAY ESTACION SOLAR
        2: '../../../../../../assets/icons/dash/Vector45.svg', //SENSOR PIN PIR
        3: '../../../../../../assets/icons/dash/Vector45.svg', //DISPOSITIVO ASOCIADO A ZONA
        8: '../../../../../../assets/icons/dash/camioneta-yellow.png', //CAMIONETA
        9: '../../../../../../assets/icons/dash/retroescavadora-yellow.png', //Pala
        4: '../../../../../../assets/icons/dash/transformador-yellow.png', //transformador
      },// '../../../../../../assets/icons/dash/icon-mapa-3.svg', //desarmado
      2: {//armado
        7: '../../../../../../assets/icons/dash/Vector31.svg', //camara
        1: '../../../../../../assets/icons/dash/Vector32.svg', //CAMARILLA PIN CAMARILLA
        // 4: '../../../../../../assets/icons/dash/Vector33.svg', //SENSOR MOVIMIENTO PIN MOVIMIENTO
        5: '../../../../../../assets/icons/dash/Vector34.svg', //SIAC-GW ESTACION SOLAR
        6: '../../../../../../assets/icons/dash/Vector34.svg', //SIAC-RELAY ESTACION SOLAR
        2: '../../../../../../assets/icons/dash/Vector35.svg', //SENSOR PIN PIR
        3: '../../../../../../assets/icons/dash/Vector35.svg', //DISPOSITIVO ASOCIADO A ZONA
        8: '../../../../../../assets/icons/dash/camioneta-green.png', //CAMIONETA
        9: '../../../../../../assets/icons/dash/retroescavadora-green.png', //Pala
        4: '../../../../../../assets/icons/dash/transformador-green.png', //transformador
      }, //'../../../../../../assets/icons/dash/icon-mapa-2.svg'
      1: {//apagado
        7: '../../../../../../assets/icons/dash/Vector26.svg', //camara
        1: '../../../../../../assets/icons/dash/Vector27.svg', //CAMARILLA PIN CAMARILLA
        // 4: '../../../../../../assets/icons/dash/Vector28.svg', //SENSOR MOVIMIENTO PIN MOVIMIENTO  => TRANSFORMADOR
        5: '../../../../../../assets/icons/dash/Vector29.svg', //SIAC-GW ESTACION SOLAR
        6: '../../../../../../assets/icons/dash/Vector29.svg', //SIAC-RELAY ESTACION SOLAR
        2: '../../../../../../assets/icons/dash/Vector30.svg', //SENSOR PIN PIR
        3: '../../../../../../assets/icons/dash/Vector30.svg', //DISPOSITIVO ASOCIADO A ZONA
        8: '../../../../../../assets/icons/dash/camioneta-gray.png', //CAMIONETA
        9: '../../../../../../assets/icons/dash/retroescavadora-gray.png', //Pala
        4: '../../../../../../assets/icons/dash/transformador-gray.png', //Pala
      }//'../../../../../../assets/icons/dash/icon-mapa-7.svg', //apagado
    };
    const statusId = this.getMarkerStatusId(location, alarmList, device);
    const locationTypeId = Number(location && location.location_type_id);
    // Si la ubicación tiene una alarma activa, el pin debe reflejar Alarmado
    // aunque el estado persistido de la ubicación todavía indique Armado.
    return urlMap[statusId]?.[locationTypeId]
      || urlMap[2]?.[locationTypeId]
      || urlMap[1]?.[locationTypeId]
      || 'assets/images/icons/icon-siac.png';
  }

  /**
   * @brief Resuelve el estado visual del pin usando la misma prioridad que la leyenda.
   * @param {any} location - Ubicación del marcador.
   * @param {any[]} alarmList - Alarmas asociadas a la ubicación.
   * @returns {number} ID de estado SIAC (1 apagado, 2 armado, 3 des-armado, 4 alarmado, 5 bloqueado).
   */
  private getMarkerStatusId(location: any, alarmList: any[] = [], device: any = null): number {
    const hasActiveAlarm = (alarmList || []).some(alarm => {
      const alarmStatusId = Number(alarm?.alarm_status_id ?? alarm?.AlarmStatus?.id);
      // El estado 2 representa una alarma cerrada; cualquier otro estado
      // mantiene el pin en rojo, igual que el resumen del new-dashboard.
      return !alarmStatusId || alarmStatusId !== 2;
    });
    if (hasActiveAlarm) return 4;

    const deviceStatusId = Number(device?.siac_status_id);
    if (this.statusMap[deviceStatusId]) return deviceStatusId;

    const locationStatusId = Number(location?.siac_status_id);
    if (this.statusMap[locationStatusId]) return locationStatusId;

    const relatedDeviceStatusId = this.getLocationDevices(location)
      .map(device => Number(device?.siac_status_id))
      .find(statusId => !!this.statusMap[statusId]);
    return relatedDeviceStatusId || 1;
  }

  async openFilterModal(){
    console.log("open filter modal")
    this.openModal(this.modalTemplate, {})
    // const modal = await this.modalController.create({
    //   component:  FilterMapModal,
    //   cssClass: 'mimodaldetail',
    //   componentProps: {
    //     installationList: this.installationList_
    //   },
    // });

    // modal.onDidDismiss()
    //   .then((data) => {
    //     console.dir(data);
    //     const filteredLocationList = data['data']; // Here's your selected user!
    //     if(filteredLocationList){
    //       this.setLocations(filteredLocationList);
    //       this.counter = filteredLocationList.length;
    //     }
    // })
    // return await modal.present();
  }

  async openSensorModal(location, device: any = null){
    console.log("open filter modal")
    this.openModal(this.modalTemplate, {location, device, type: 'device-popover'})
    // const modal = await this.modalController.create({
    //   component:  DevicePopoverComponent,
    //   cssClass: 'mimodaldetail',
    //   componentProps: {
    //     location
    //   },
    // });
    // return await modal.present();
  }

  async openZoneModal(location, device: any = null){
    console.log("open zone modal")
    try{
    this.openModal(this.modalTemplate, {location, device, type: 'variable'})
    }catch(err){
      console.dir(err);
    }
    // const modal = await this.modalController.create({
    //   component:  VariableHistoryPage,
    //   cssClass: 'mimodaldetail',
    //   componentProps: {
    //     location
    //   },
    // });
    // return await modal.present();
  }

  async openCameraModal(location, device: any = null){
    console.log("open camera modal")
    this.openModal(this.modalTemplate, {location, device, type: 'camera'})
    // const modal = await this.modalController.create({
    //   component:  CameraModalComponent,
    //   cssClass: 'mimodaldetail',
    //   componentProps: {
    //     location
    //   },
    // });
    // return await modal.present();
  }

  async openTransformerModal(location, initialTab: 'alarms' | 'history' | 'voltage' = 'history', alarmList?: any[], device: any = null){
    console.log("open transformer modal")
    const locationAlarms = alarmList || this.getLocationAlarmList(location.id, device);
    this.openModal(this.modalTemplate, {
      location,
      device,
      type: 'transformer',
      initialTab,
      markerIconUrl: this.getLocationImageUrl(location, locationAlarms, device),
      alarmList: locationAlarms
    })
    // const modal = await this.modalController.create({
    //   component:  CameraModalComponent,
    //   cssClass: 'mimodaldetail',
    //   componentProps: {
    //     location
    //   },
    // });
    // return await modal.present();
  }

  openTransformerAlarmModal(event: Event, marker: any): void {
    event.preventDefault();
    event.stopPropagation();
    this.openTransformerModal(marker.location, 'alarms', marker.alarmList || [], marker.device || null);
  }

  private getLocationAlarmList(locationId: number, device: any = null): any[] {
    const deviceId = device && Number(device.id);
    const marker = (this.markers || []).find(item =>
      Number(item.location_id) === Number(locationId) &&
      (deviceId ? Number(item.device_id) === deviceId : !item.device_id)
    );
    return marker && Array.isArray(marker.alarmList) ? marker.alarmList : [];
  }

  async openNodeModal(location, device: any = null){
    console.log("open filter modal")
    this.openModal(this.modalTemplate, {location, device, type: 'device-popover'})
    // const modal = await this.modalController.create({
    //   component:  DevicePopoverComponent,
    //   cssClass: 'mimodaldetail',
    //   componentProps: {
    //     location
    //   },
    // });
    // return await modal.present();
  }
  
  async openGWModal(location, device: any = null){
    console.log("open filter modal")
    this.openModal(this.modalTemplate, {location, device, type: 'device-popover'})
    // const modal = await this.modalController.create({
    //   component:  DevicePopoverComponent,
    //   cssClass: 'mimodaldetail',
    //   componentProps: {
    //     location
    //   },
    // });
    // return await modal.present();
  }

  async openRelayModal(location, device: any = null){
    console.log("open filter modal")
    this.openModal(this.modalTemplate, {location, device, type: 'device-popover'})
    // const modal = await this.modalController.create({
    //   component:  DevicePopoverComponent,
    //   cssClass: 'mimodaldetail',
    //   componentProps: {
    //     location
    //   },
    // });
    // return await modal.present();
  }

  private getAlarmLocationId(alarm: any): number {
    return Number(_.get(alarm, 'Device.location_id') || _.get(alarm, 'Device.Location.id') || alarm && alarm.location_id);
  }

  async openGenericLocationModal(location, device: any = null){
    this.openModal(this.modalTemplate, {location, device, type: 'generic'});
  }

  getLocationTypeLabel(location: any): string {
    return _.get(location, 'LocationType.name') || _.get(location, 'location_type.name') ||
      (location && location.location_type_id ? `Tipo de ubicación ${location.location_type_id}` : 'Ubicación');
  }
  // modal Open Small
  openModal(template, data) {
    try{
    this.modalData = data;
    console.log("modal data: ");console.dir(this.modalData)
    const windowClass = data && data.type === 'transformer'
      ? 'asset-monitor-dialog'
      : data && data.type === 'variable'
        ? 'siac-location-dialog siac-zone-dialog'
        : 'siac-location-dialog';
    this.modalService.open(template, {
      centered: true,
      size: data && data.type === 'transformer' ? 'xl' : 'lg',
      windowClass
    });
  }catch(err){
    console.dir(err);
  }
  }

  // toggleFullscreen() {
  //   const mapDiv = this.map.googleMap?.getDiv()?.firstChild as HTMLElement;
  //   if (document.fullscreenElement) {
  //     console.log("EXIT FULLSCREEN")
  //     document.exitFullscreen();
  //   } else {
  //     console.log("ENTER FULLSCREEN")
  //     mapDiv.requestFullscreen();
  //   }
  // }
  addFullScreenButton(){
    this.subscriptions.push(
      interval(100).pipe(
        filter(()=>this.map!=undefined),
        take(1)
      ).subscribe(()=>{
      const btnFullscreen = document.createElement('button');
      const fullscreenIcon = '<img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23111%22%20d%3D%22M0%200v6h2V2h4V0H0zm16%200h-4v2h4v4h2V0h-2zm0%2016h-4v2h6v-6h-2v4zM2%2012H0v6h6v-2H2v-4z%22/%3E%3C/svg%3E">';
      const exitFullscreenIcon = '<img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23666%22%20d%3D%22M4%204H0v2h6V0H4v4zm10%200V0h-2v6h6V4h-4zm-2%2014h2v-4h4v-2h-6v6zM0%2014h4v4h2v-6H0v2z%22/%3E%3C/svg%3E">';
      btnFullscreen.innerHTML = this.isFullscreen ? exitFullscreenIcon : fullscreenIcon;
      btnFullscreen.classList.add('fullscreen-btn');
      btnFullscreen.style.position = 'absolute';
      btnFullscreen.style.top = '10px';
      btnFullscreen.style.right = '10px';
      btnFullscreen.style.zIndex = '5';
      btnFullscreen.style.height = '40px';
      btnFullscreen.style.width = '40px';
      btnFullscreen.style.margin = '10px';
      btnFullscreen.style.backgroundColor = 'white';
      btnFullscreen.style.borderRadius = '10px';
      btnFullscreen.style.border = '1px solid #ddd';
      btnFullscreen.addEventListener('click', () => {
        this.openFullscreenMap();
        // btnFullscreen.innerHTML = this.isFullscreen ? exitFullscreenIcon : fullscreenIcon;
      });
      this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(btnFullscreen);

    }))
  }

  async openFullscreenMap(): Promise<void> {
    const {NewInstallationMapComponent} = await import('../new-installation-map/new-installation-map.component');
    this.modalService.open(NewInstallationMapComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'siac-new-map-dialog'
    });
  }

  addCam(){
    /*this.subscriptions.push(
      interval(100).pipe(
        filter(()=>this.map!=undefined),
        take(1)
      ).subscribe(()=>{
          const div = document.createElement('div');
          div.id = 'cam';
          div.style.position = 'absolute';
          div.style.width = '200px';
          div.style.height = '120px';
          div.style.backgroundColor = 'black';
          div.style.color = 'white';
          div.style.borderRadius = '10px';
          div.style.padding = '10px';
          div.style.left = '0';
          div.style.display = 'none';
          div.innerHTML = 'CÁMARA';
          this.map.googleMap.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(div);
      }))*/
  }
  addlistAlarm(){
    console.log("ADD LIST ALARM =====================")
    this.subscriptions.push(
      interval(100).pipe(
        filter(()=>this.map!=undefined),
        take(1)
      ).subscribe(()=>{
        const div = document.getElementById('lista-alarmas');
        if (div) {
          let div2 = document.getElementById('lista-alarmas2') as HTMLDivElement;
            div2 = div.cloneNode(true) as HTMLDivElement;
            div2.id = 'lista-alarmas2';
            div2.style.display = 'none';
            div2.style.backgroundColor = 'rgba(40, 48, 70, 0.8)';
            div2.style.height = '300px';
            div2.style.width = '50%';
            div2.style.transform = 'scale(1.2)';
            div2.style.overflowY = 'auto';
            const buttonHtml = `
              <button type="button" id="expandBoxButton" style="position: absolute; top: 15px; right: 15px; padding: 5px;" class="btn btn-sm btn-success">
                <i class="fa ${this.expandBox ? 'fa-chevron-up' : 'fa-chevron-down'}"></i>
              </button>
            `;
            div2.querySelector('h4')?.insertAdjacentHTML('afterend', buttonHtml);
            const expandBoxButton = div2.querySelector('#expandBoxButton');
            expandBoxButton?.addEventListener('click', () => this.expandedBox());

            this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(div2);
          
        }
      }))
  }
  expandedBox(){
    console.log("EXPANDED BOX")
    if(this.expandBox){
      document.getElementById('lista-alarmas2').style.height = '300px';
      document.getElementById('lista-alarmas2').style.overflow = 'auto';

      this.expandBox = false;
    }else{
      document.getElementById('lista-alarmas2').style.height = '60px';
      document.getElementById('lista-alarmas2').style.overflow = 'hidden';
      this.expandBox = true;
    }
  }


  toggleFullscreen() {
    this.isFullscreen = !this.isFullscreen;
    const mapDiv = document.querySelector('.dashmap');
    const mapDivGoogle = this.map.googleMap?.getDiv()?.firstChild as HTMLElement;
    const mapContainer = document.querySelector('.map-container') as HTMLElement;
    if (this.isFullscreen) {
      mapDiv.classList.add('fullscreen-modal');
      mapDivGoogle.style.height = '95vh';
      mapContainer.style.height = '95vh';
      mapDivGoogle.style.borderRadius = '20px';
      mapContainer.style.borderRadius = '20px';

      /*const cam = document.getElementById('cam');
      if(cam){
        cam.style.display = 'block';
      }
      const listaAlarmas = document.getElementById('lista-alarmas2');
      if(listaAlarmas){
        listaAlarmas.style.display = 'block';
        this.addlistAlarm();
      }*/

    } else {
      mapDiv.classList.remove('fullscreen-modal');
      mapDivGoogle.style.height = '400px';
      mapContainer.style.height = '400px';
      const cam = document.getElementById('cam');
      if(cam){
        cam.style.display = 'none';
      }
      const listaAlarmas = document.getElementById('lista-alarmas2');
      if(listaAlarmas){
        listaAlarmas.style.display = 'none';
      }
    }
  }
  // ESC CLOSE FULLSCREEN

  @HostListener('document:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape' && this.isFullscreen) {
        this.toggleFullscreen();
        const btnFullscreen = document.querySelector('.fullscreen-btn') as HTMLElement;
        const fullscreenIcon = '<img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23111%22%20d%3D%22M0%200v6h2V2h4V0H0zm16%200h-4v2h4v4h2V0h-2zm0%2016h-4v2h6v-6h-2v4zM2%2012H0v6h6v-2H2v-4z%22/%3E%3C/svg%3E">';
        const exitFullscreenIcon = '<img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23666%22%20d%3D%22M4%204H0v2h6V0H4v4zm10%200V0h-2v6h6V4h-4zm-2%2014h2v-4h4v-2h-6v6zM0%2014h4v4h2v-6H0v2z%22/%3E%3C/svg%3E">';
        btnFullscreen.innerHTML = this.isFullscreen ? exitFullscreenIcon : fullscreenIcon;
        const cam = document.getElementById('cam');
        if(cam){
          cam.style.display = 'none';
        }
        const listaAlarmas = document.getElementById('lista-alarmas2');
        if(listaAlarmas){
          listaAlarmas.style.display = 'none';
        }
      }
  }


  ngOnDestroy(){
    // Marcar primero la instancia como inválida: una respuesta HTTP, un
    // ResizeObserver o un frame de Google Maps puede llegar durante el mismo
    // ciclo en que Angular desmonta la vista.
    this.destroyed = true;
    if (this.alarmInfoSubscription) this.alarmInfoSubscription.unsubscribe();
    this.pendingTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
    this.pendingTimeouts.clear();
    if (this.tooltipResizeObserver) {
      this.tooltipResizeObserver.disconnect();
      this.tooltipResizeObserver = null;
    }
    if (this.tooltipConnectorAnimationFrame !== null) {
      cancelAnimationFrame(this.tooltipConnectorAnimationFrame);
      this.tooltipConnectorAnimationFrame = null;
    }
    if (this.tooltipConnectorMeasurementFrame !== null) {
      cancelAnimationFrame(this.tooltipConnectorMeasurementFrame);
      this.tooltipConnectorMeasurementFrame = null;
    }
    if (this.tooltipConnectorMeasurementSecondFrame !== null) {
      cancelAnimationFrame(this.tooltipConnectorMeasurementSecondFrame);
      this.tooltipConnectorMeasurementSecondFrame = null;
    }
    this.tooltipConnectorSettleFrames = 0;
    this.tooltipConnectorZoom = null;
    this.tooltipConnectorForceUpdate = false;
    // Cierra explícitamente los InfoWindows nativos. Así no queda un overlay
    // visible si Google Maps procesa el cierre de la directiva después de la
    // navegación.
    if (this.infoWindowList) {
      this.infoWindowList.forEach(infoWindow => infoWindow.close());
    }
    this.tooltipConnectors = [];
    this.markers = [];
    this.polyLines = [];
    this.markersLoaded = false;
    this.automaticallyOpenedInfoWindowIds.clear();
    this.subscriptions.forEach(sub=>sub.unsubscribe());
    this.subscriptions = [];
  }

  openInfoWindow(marker: any | MapMarker, infoWindow: MapInfoWindow) {
    if (this.destroyed) return;
    console.log("OPEN INFO WINDOW", {marker, infoWindow})
    infoWindow.open(marker);
  }
}

const  colorSvg = (url, color)=> {
  // add color to svg
  return `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='${color}' width='24' height='24' viewBox='0 0 24 24'><path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z'/><path d='M0 0h24v24H0z' fill='none'/></svg>`;
}
